<template>
  <!-- <div id="home" v-if="userDetails.v3 && !autopilotValid && !hop">
    <template v-for="(section, index) in userDetails.sections">
      <component 
        :is="getSectionComponent(section.type)" 
        v-if="getSectionComponent(section.type)"
        :key="index"
        :section="section"
        :id="'section_'+index"
        v-bind="getSectionProps(section.type, index)"
      >
        <template #fallback>
          <div>Loading {{ section.type }} section...</div>
        </template>
      </component>
    </template>

    <component
      v-if="userDetails.account === 0 && randomAd"
      :is="getSectionComponent('adverts')"
      :section="{ type: 'adverts' }"
      :advert="randomAd"
      :userDetails="userDetails"
    />
  </div> -->
  <div id="home" v-if="!autopilotValid && !hop" style="background-size:cover; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-attachment: fixed; background-position:center center;">
  <!-- <div id="home" v-if="!autopilotValid && !hop" style="min-height: -webkit-fill-available; background-size:cover; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-attachment: fixed; background-position:center center;"> -->
  <!-- <div id="home" v-if="!autopilotValid && !hop" style="min-height: -webkit-fill-available; background-size:cover; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-attachment: fixed; background-position:center center;" v-bind:style="getBackground"> -->
            <!-- <div v-if="isDev || isLocal" class="ribbon ribbon-top-left" style="opacity: 0.75;"><span>DEVELOPMENT</span></div> -->
    <div v-if="userDetails.sensitiveContent && visitorAge == null" class="sensitiveContent" style="display: flex; max-width:400px; margin-left:auto; margin-right:auto; flex-flow: column;height: 100vh; max-height: 100vh; padding: 30vh 0 20px 0; color:black;justify-content:space-between" >
    <div style="background:#ffffff; display:flex; flex-flow:column; gap:20px; overflow:hidden; margin: 0 40px; border-radius: 10px; box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);">
      <h1 style="margin-bottom:unset">
        <img v-bind:src="getSensitiveUserPicture" style="object-fit: cover; min-width: 105px; min-height: 105px; max-width: 105px; max-height: 105px; border-radius: 100px; border: 1px solid grey; ">
      </h1>
      <h1 style="margin:unset">Sensitive Content</h1>
      <div style="padding:0 20px; text-align:center;"><b>{{userDetails.name}}</b> has marked some of their content as sensitive.</div>
      <div style="width:100%; display: grid; grid-template-columns: repeat(2, 1fr);">
        <md-button class="md-raised md-dense" style="margin:unset; border-radius: unset; border-top: 3px solid darkred; background: #8B000022" @click="setVistorAge(false)">I'm Under 18</md-button> 
        <md-button class="md-raised md-dense" style="margin:unset; border-radius: unset; border-top: 3px solid darkgreen; background:#00640022" @click="setVistorAge(true)">I'm Over 18</md-button> 
      </div>
      </div>
      <div class="bottomBar" style="bottom:0; padding:20px; text-align:center; max-width:100vw; width:100%">
        <router-link v-bind:to="'/?utm_source='+ profile['.key'] +'&utm_medium=Footer'" class="" style="color:black; font-weight:bold; font-size:smaller; text-transform:uppercase">
          <md-icon md-src="/static/favicon.png"></md-icon><br>Slink
        </router-link>
      </div>

    </div>
   
     <!-- <div v-else v-bind:style="getCustomFont"> -->
      
    <!-- <md-layout v-else v-bind:style="getCustomFont"> -->
      <!-- <md-layout md-hide-xsmall md-flex-small="25" md-flex-medium="25" md-flex-large="35" md-flex-xlarge="33"><div></div></md-layout> -->
      <!-- <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="50"  md-flex-large="30" md-flex-xlarge="33"> -->
     <div v-else v-bind:style="getCustomFont" class="mainContainer" v-bind:class="{'desktopFullscreen': userDetails.desktopFullscreen }" style="display:block;max-width:450px; margin: 0px auto; flex: 1 1 0%; flex-direction: column; -webkit-box-pack: justify; justify-content: space-between; height: 100%; width: 100%;">
      <!-- <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="50"  md-flex-large="30" md-flex-xlarge="33" style="display:flex;    flex: 1 1 0%;
    flex-direction: column;
    -webkit-box-pack: justify;
    justify-content: space-between;
    min-height: 100%; 
    width: 100%;">-->
    <div v-if="userDetails.autoBackground" class="backgroundWallpaper">
      <div class="filter"></div>
    </div>
    <div v-else-if="userDetails.videoBackground" class="backgroundVideo" v-bind:style="{background: userDetails.background}">
      <video :src="userDetails.videoBackground" muted="muted" autoplay="autoplay" loop="loop" :poster="userDetails.videoPoster" playsinline="" v-bind:style="[userDetails.videoBackgroundStyling]" style="object-fit: cover; height:100vh">
    <!-- <source src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F-NBNYbfKntF_uDtaTcNO%2FSnapTik_7133543292142210310.mp4?alt=media&amp;token=cc106929-def0-409d-852f-6cae2d4ba15f" type="video/webm"> -->
    <!-- Your browser does not support the video tag. -->
</video>
    </div>
        <div v-if="userDetails.warning" class="warning">
          <md-avatar class="md-large pulse"><md-icon>error_outline</md-icon></md-avatar>
          <div class="text">
            <h3>WARNING!</h3>
            <span style="white-space: pre-wrap; position: relative;top: -16px;" >THIS PAGE IS UNDER REVIEW FOR SUSPICIOUS ACTIVITY.<br>THE LINKS HAVE BEEN DISABLED FOR YOUR SECURITY!</span>
          </div>
        </div>


        <!-- <md-whiteframe :md-elevation="getWhiteFrame" style="width:calc(100% - 40px);" v-bind:class="{fixedFrame: userDetails.fixedFrame}" v-bind:style="{'margin': fullScreenPadding, 'border-radius': borderRadius, 'overflow': getFloatingOverflow, 'width': setPageWidth}"> -->
            <!-- <div v-if="isDev || isLocal" class="ribbon ribbon-top-left" style="opacity: 0.75;"><span>DEVELOPMENT</span></div> -->
        
        <!-- <h1>{{  referrer }}</h1> -->
          <div class="slinksContainer" :class="{['floating']:userDetails.floating && userDetails.account == 7 && !userDetails.fullScreen, ['notFloating']:!userDetails.floating || userDetails.account != 7, 'flat': userDetails.flat, 'iOSDevice':isIOS, 'fullScreen':userDetails.fullScreen, 'albumPlayerMargin': userDetails.albumPlayer}" v-bind:style="[userDetails.slinksContainer]">
          <!-- <md-list class="md-double-line" v-bind:class="{flat: userDetails.flat, floating: ((isAllowed(7)) && userDetails.floating && !userDetails.fullScreen)}" style="height: 100%; background:unset;" id="top"> -->
            <div class="diagnostics" v-if="userDetails.diagnostics" style="background:white; border:1px solid whitesmoke; border-radius:10px; padding:5px 10px ; margin-bottom:10px">
              <div style="width:100%; border-bottom:1px solid black">Diagnostics</div>
              <p style="margin:5px 0px;font-size:smaller">dF:  {{documentReferrer}}</p>
              <p v-for="(log, index) in getDiagnostics" v-bind:key="index" style="margin:5px 0px;font-size:smaller">{{log}}</p>
            </div>

            <!-- <div v-if="userDetails.beta1" style="width:100%; display:grid; justify-content:center;padding:20px; background: pink">
      <svg width="0" height="0" style="border:0px solid red" >
  <defs>
    <clipPath id="squircleIOS" clipPathUnits="objectBoundingBox">
      <path d="M .5,0 C .1,0 0,.1 0,.5 0,.9 .1,1 .5,1 .9,1 1,.9 1,.5 1,.1 .9,0 .5,0 Z"></path>
    </clipPath>
  </defs>
</svg>

<img v-bind:src="getUserPicture" style="-webkit-clip-path:url(#squircleIOS);
  clip-path:url(#squircleIOS);
  width:100px !important;
  height:100px !important;
  object-position: center;
  object-fit: cover;
  position:relative;" >
</div> -->

            <!-- PROFILE LAYOUT -->
            <profileheader
              :userDetails="userDetails" 
              :altProfile=getProfile() 
              :picture="userDetails.picture" 
              :bio="userDetails.bio" 
              :account="parseInt(userDetails.account)" 
              :nameHide="userDetails.nameHide" 
              :enableUpgrades="userDetails.enableUpgrades" :uid="profile['.key']"
              v-bind:class="{ stickyProfile: userDetails.altProfileSticky, noborder: userDetails.altProfile == 43 || userDetails.altProfile == 41 || userDetails.altProfile == 38 || userDetails.altProfile == 5 || userDetails.altProfile == 14|| userDetails.altProfile == 29 || userDetails.altProfile == 21 || userDetails.altProfile == 25 || userDetails.altProfile == 32, 'linkBorder': userDetails.linkBorder && (userDetails.altProfile != 43 && userDetails.altProfile != 41 && userDetails.altProfile != 5 && userDetails.altProfile != 14 && userDetails.altProfile != 29 && userDetails.altProfile != 21  && userDetails.altProfile != 24 && userDetails.altProfile != 32 && userDetails.altProfile != 38) && userDetails.floating}" class="slinkItems"
            >
            </profileheader>

            
            
            <!-- TEMPLATE LINKS ABOVE -->
            <!-- <div v-if="templateLinks && Object.keys(templateLinks.above).length > 0" id="templateLinks above">
              <links class="slinkItems" v-for="(link, index) in templateLinks.above" v-bind:key="'above'+index" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)"/>
            </div> -->
            <div v-if="templateLinks && templateLinks.above" class="templateBelow" :class="{'floating': userDetails.floating}">
              <links class="slinkItems" v-for="(link, index) in templateLinks.above" v-bind:key="'below'+index" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)" :class="{'shake': link.shake, 'linkBorder': userDetails.linkBorder && userDetails.floating}"/>
            </div>

            <div v-for="(link, index) in slinks" v-bind:key="index" v-if="!link.group && linkEnabled(link) && !link.quicklink" :id="link.site" class="slinkItems userLinks" :class="{bookmarkFullScreen: userDetails.fullScreen,'qlbTransparent': (link.site == 'QuickLinks' && link.transparent), 'shake': link.shake, 'linkBorder': userDetails.linkBorder && userDetails.floating && link.site != 'Section', 'allowOverflow': link.site == 'Album Player'}" v-bind:style="userDetails.userLinksStyle" style="z-index: 0;transform: translateZ(0);">

              <!-- <div v-if="link.site && !link.quicklink" style="backdrop-filter: blur(1px);"> -->
                <links v-if="link.site != 'Album Player' && !getSlinkCanInLine(link.site) && link.site != 'Image' && link.site != 'Bookmarks' && link.site != 'QuickLinks' && link.site != 'Search' && link.site != 'Download'" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)"/>
                <links v-else-if="link.site != 'Section' && !getSlinkCanInLine(link.site) && link.site != 'Image' && link.site != 'Bookmarks' && link.site != 'QuickLinks' && link.site != 'Search' && link.site == 'Download'" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)" @click="downloadvCard()" />
                
                <!-- SECTION` -->
                <!-- <md-list-item v-else-if="link.site == 'Section' && link.site != 'Bookmarks' && link.site != 'Search' && link.site != 'QuickLinks'" class="section links" :id="'section_'+link.id">
                  <div class="md-list-text-container"  v-bind:style="textAlign">
                    <h3 style="white-space:normal"><span>{{link.user}}</span></h3>
                    <span class="customDescription" v-if="userDetails.account == 7" style="">{{ link.customdescription }}</span>
                  </div>
                  <md-divider></md-divider>
                </md-list-item> -->
                <links v-else-if="link.site == 'Album Player'" @childEvent="handleLinkEvent" :link="link" :user="{...userInfo, activeTrack: albumPlayer ? albumPlayer.index : 0}" :linkFormatting="linkFormatting(link.site)" class="XXX" />


                <!-- BOOKMARKS -->
                <div v-else-if="link.site == 'Bookmarks' && (isAllowed(7))" v-bind:style="{background: link.background, color: fullColourButtonsText(link.background, link.ForceTextColour, link.color)}" class="links bookmarks" v-bind:class="{bookmarkFullScreen: userDetails.fullScreen}">
                  <!-- <md-button class="md-dense md-raised md-icon-button bookmark home" @click="scrollTo('#top')">
                    <md-icon style="font-size: 20px; background:white; color:black;line-height: 24px;" >account_circle</md-icon>
                  </md-button> -->
                  <md-button class="md-dense md-raised bookmark"  @click="scrollTo('#section_'+section.id)" v-for="(section, index) in sections(link.bookmarksOrdered)" v-bind:key="index">{{section.user}}</md-button>
                </div>

                <!-- IMAGE -->
                <links v-else-if="(isAllowed(7)) && link.site == 'Image' && link.safeSearchResults.approved" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)" />
                <div v-else-if="(isAllowed(7)) && link.site == 'Image' && !link.safeSearchResults.approved" />

                <!-- BOOKMARK SEARCH -->
                <!-- <div v-else-if="link.site == 'Search'" class="links bookmarks">
                    <md-button class="md-dense md-raised md-icon-button" @click="scrollTo('#top')" style=" font-size: smaller; border-radius: 50px; font-weight: bold; min-height: 24px; line-height: 24px; height: 24px; min-width: 24px; width: 24px; margin: 6px 4px">
                      <md-icon style="font-size: 20px; top: 3px;">search</md-icon>
                    </md-button>
                     <input type="text" id="fname" name="fname">
                </div> -->
               
                <!-- EXPANDED GROUP -->
                
               <details class="link" :class="{['style'+userDetails.iconStyle]:true, 'compact':userDetails.compactLinks}" :id="'section_'+link.id" v-else-if="(isAllowed(7)) && !link.inline && link.site == 'Link Group'"  style="padding:unset" v-bind:style="{background: link.background}">

<!-- <linkinfo v-if="link.info" :adult="link.adult" :info="inGroup(link.id).length" /> -->
<!-- <linkinfo v-if="link.showChildCount" :link="link" :childCount="inGroup(link.id).length" :compact="userDetails.compactLinks" isSlinkView=true /> -->
                
                  <summary v-if="link.linkGroupImageHeader != undefined" :id="link.id" v-bind:style="{color: getTextColour(link)}" v-bind:class="{'imageHeader': link.linkGroupImageHeader}">
                   <img :src="link.linkGroupImageHeader" />
                   <div class="text" v-if="link.title" v-bind:style="{color: getTextColour(link)}" style="padding: 8px; padding-top: 8px; padding-bottom: 8px; align-items: center; display: grid !important; width: 100%;">
                        <div class="title" v-bind:style="{color: getTextColour(link)}" v-if="link.description && link.showChildCount" v-html="link.description + 'x'" style="font-weight:bold; font-size:16px;"></div>
                        <div class="title" v-bind:style="{color: getTextColour(link)}" v-else-if="link.description" v-html="link.description" style="font-weight:bold; font-size:16px;"></div>
                        <div class="title" v-bind:style="{color: getTextColour(link)}" v-else>{{link.site}}</div>
                        <div class="description" v-bind:style="{color: getTextColour(link)}" v-if="link.customdescription" v-html="link.customdescription"></div>
                    </div>
                  </summary>
                  <summary v-else :id="link.id" style="">
<!-- <linkinfo :info="inGroup(link.id).length" /> -->

                   
                    
                    <div style="display: grid !important;
    grid-template-columns: 80px auto 40px;
    min-height: 56px;
    row-gap: 12px;
    column-gap: 12px;" class="container" v-bind:style="{background:getDropBackground(userDetails.fullColour, link.background)}">
                    <div class="icon">
                      <siteicon v-if="!userDetails.showIcons" :account="parseInt(userDetails.account)" :enableUpgrades="userDetails.enableUpgrades" :link="link" :compact="userDetails.compactLinks" :iconStyle="userDetails.iconStyle"/>
                    </div>
                    <div class="text" v-bind:style="{color: getTextColour(link)}" style="padding-top: 8px; padding-bottom: 8px; padding-left:unset;align-items: center; display: grid !important; width: 100%;">
                        <div class="title" v-bind:style="{color: getTextColour(link)}" v-if="link.description && link.showChildCount" v-html="link.description + ' (' + inGroup(link.id).length + ')'" style="font-weight:bold; font-size:16px;"></div>
                        <!-- <div class="title" v-bind:style="{color: getTextColour(link)}" v-if="link.description && link.showChildCount" v-html="link.description + ' (' + inGroup(link.id).length + ')'" style="font-weight:bold; font-size:16px;">{{link.site}}</div> -->
                        <div class="title" v-bind:style="{color: getTextColour(link)}" v-else-if="link.description && link.showChildCount != true" v-html="link.description" style="font-weight:bold; font-size:16px;"></div>
                        <!-- <div class="title" v-bind:style="{color: getTextColour(link)}" v-else-if="link.description && link.showChildCount != true" v-html="link.description" style="font-weight:bold; font-size:16px;">{{link.site}}</div> -->
                        <div class="title" v-bind:style="{color: getTextColour(link)}" v-else>{{link.site}}</div>
                        <div class="description" v-bind:style="{color: getTextColour(link)}" v-if="link.customdescription" v-html="link.customdescription"></div>
                    </div>
                    <div class="chevron" style="padding-top:16px">
                      <md-icon class="more">expand_more</md-icon>
                      <md-icon class="less">expand_less</md-icon>
                    </div>
                    </div>
                  </summary>
                  <div class="linkgroupContainer" v-bind:style="link.containerStyle">
                        <links v-for="(groupLink, index) in inGroup(link.id)" v-if="groupLink.quicklink != true" v-bind:key="index"  :link="groupLink" :user="userInfo" :linkFormatting="linkFormatting(groupLink.site)" :class="{'shake': groupLink.shake, 'grid':link.containerStyle}" style="grid-template: unset; min-height: 56px;"/>
                </div>
                        <!-- <links v-for="(groupLink, index) in inGroup(link.id)" v-if="groupLink.quicklink != true" v-bind:key="index"  :link="groupLink" :user="userInfo" :linkFormatting="linkFormatting(groupLink.site)" :class="{'shake': groupLink.shake}" style="grid-template: unset;
    min-height: 56px;"/> -->
                      
                </details>



                <!-- INLINE LINKGROUP -->
                <div v-else-if="(isAllowed(7)) && link.inline && link.site == 'Link Group' || link.site == 'Link Grid'" :id="'section_'+link.id" v-bind:class="{'linkgridContainer': link.site == 'Link Grid'}" class="imageSlink links grouped" v-bind:style="{background: link.background}" style="display:block;margin:0px;width:100%;max-width:100%">
                  <div v-if="link.title" style="padding:8px 16px;">
                    <div class="description" style="font-weight:bold; font-size:16px;" v-html="link.description"></div>
        <div  v-html="link.customdescription"></div>
      </div>
                 <links v-if="link.title != false && !link.site === 'Link Grid'" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)" />
                 <div v-if="link.site === 'Link Group'" class="linkgroupContainer" v-bind:style="link.containerStyle">
                    <links v-for="(groupLink, index) in inGroup(link.id)" v-bind:key="index" v-if="groupLink.quicklink != true"  :link="groupLink" :user="userInfo" :linkFormatting="linkFormatting(groupLink.site)" :class="{'shake': groupLink.shake, 'grid':link.containerStyle}" />
                  </div>
                  <div v-if="link.site === 'Link Grid'" class="linkgridContainer" v-bind:style="link.containerStyle" style="gap: 10px; display:flex; flex-wrap:wrap; justify-content:space-evenly/* Add gap between items */">
                    <links v-for="(groupLink, index) in inGroup(link.id)" v-bind:key="index" v-if="groupLink.quicklink != true || link.linkGrid == true"  :link="groupLink" :user="userInfo" :linkFormatting="linkFormatting(groupLink.site)" :class="{'shake': groupLink.shake, 'grid':link.containerStyle}" />
                  </div>
                  <!-- <links v-for="(groupLink, index) in inGroup(link.id)" v-bind:key="index" v-if="groupLink.quicklink != true"  :link="groupLink" :user="userInfo" :linkFormatting="linkFormatting(groupLink.site)" :class="{'shake': groupLink.shake}" /> -->
                
                </div>

                <div v-else-if="(isAllowed(7)) && link.inline && link.site != 'Gallery'" class="imageSlink links" style="position:relative;margin:0px;width:100%;max-width:100%;" v-bind:style="{background: fullColourButtons('#ffffff')}" v-bind:class="{flat: userDetails.flat}">
                  <links v-if="getSlinkCanInLine(link.site) && !link.group" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)" />

                  <table v-else-if="link.site == 'List'"  style="width:100%;border-spacing: unset">
                    <thead v-if="link.inline">
                      <tr>
                        <th style="padding-left:20px;padding-right:20px" v-if="link.description" colspan=2>{{link.description}}<span v-if="link.customdescription" style="font-weight:normal"><br>{{link.customdescription}}</span></th>
                        <th style="padding-left:20px;padding-right:20px" v-else colspan=2>{{link.site}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(listItem, index) in listOrder(link.list)" v-bind:key="index" v-if="listItem">
                        <th style="width:35%; padding-left:20px">{{listItem.item}}</th><td style="padding-right:20px">{{listItem.value}}</td>
                      </tr>
                    </tbody>
                  </table>

                <iframe v-else :onload="mediaHeight(link.id, link.site, link.user)" :id="link.id" :ref="link.id" v-bind:style="{'background':link.background}" width="100%" style="border:unset; width:100%; "></iframe>

                <div v-if="link.password && (link.password != linkPasswords[link.id]) && !getSlinkCanInLine(link.site)" style="border-radius:10px;backdrop-filter: blur(10px);width:100%; height:100%; top:0; left:0; position:absolute;padding:10px 24px;font-weight:bold; text-align:center">
                  <div style="margin-top: 10%; border-radius: 10px; border: 1px solid grey; padding: 10px; max-height: 118px; background: #ffffff9f;"> This content is password protected.
                    <md-input-container md-has-password style="max-width:75%;margin-right: auto;margin-left: auto;">
                      <label>Passwordsss</label>
                      <md-input v-model="linkPasswords[link.id]" type="password"></md-input>
                    </md-input-container>
                  </div>
                </div>
              </div>
                <!-- </md-list-item> -->
                        

                

                <div v-else-if="(isAllowed(7)) && link.site == 'Gallery1'">
                  <md-list-item class="links" style="margin:0px;width:100%;max-width:100%;" v-if="!link.inline">
                    <md-avatar v-if="!userDetails.showIcons" class="md-large" v-bind:class="{pulse: (link.pulse && (isAllowed(7)))}" v-bind:style="{ color: link.color, background: link.background }" style="border-width: 1px; border-color: silver; border-style: solid;text-align: center;">
                      <i v-if="(link.fa && !link.favicon)" class="fa fa-fw fa-2x" v-bind:style="{ color: link.color, background: link.background }" v-bind:class="'fa-'+link.fa" aria-hidden="true" style="padding-top:16px"></i>
                      <img v-if="link.favicon && link.faviconFull == 1" v-bind:src="link.favicon" v-bind:id="link.site" @error="failedIcon"/>
                      <img v-if="link.favicon && link.faviconFull != 1" v-bind:src="link.favicon" v-bind:id="link.site" style="height:32px; width:32px; margin-left: auto; margin-right: auto; margin-top: 16px;" @error="failedIcon"/>
                    </md-avatar>
                    <!-- <linkinfo v-if="userDetails.beta && (userDetails.sensitiveContent && link.adult) || link.info" :adult="link.adult" :info="link.info" /> -->
                    <linkinfo v-if="link.adult || link.info || link.password" :link="link" :compact="userDetails.compactLinks" isSlinkView=true />
                    <div class="md-list-text-container" v-bind:style="textAlign" style="margin-top:8px; margin-bottom:8px">
                      <h3 style="white-space:normal; margin:unset;" v-bind:style="{ fontSize: userDetails.customFontSize, fontWeight: userDetails.customFontWeight, lineHeight: userDetails.customLineHeight }">
                        <span style="white-space:inherit" v-if="link.description" v-bind:style="{color: fullColourButtonsText(link.background, link.ForceTextColour, link.color)}">{{ link.description }}</span>
                        <span style="white-space:inherit" v-else v-bind:style="{color: fullColourButtonsText(link.background, link.ForceTextColour, link.color)}">{{link.site}}</span>
                      </h3>
                      <span v-bind:style="{color: fullColourButtonsText(link.background, link.ForceTextColour, link.color)}" style="position: relative; white-space: pre-wrap;">{{ link.customdescription }}</span>
                    </div>
                  </md-list-item>

                


                  <md-list-item v-if="link.format != '9cube'" class="imageSlink links" style="margin:0px;width:100%;max-width:100%">
                    <md-boards :md-auto="true" :md-infinite="true" :md-duration="5000" :md-swipeable="true" :md-controls="getGallery(link.user)">
                      <md-board v-for="(image, index) in getGallery(link.user)" v-bind:key="index" style="margin:unset; padding:unset">
                      <!-- <md-board v-for="(image, index) in link.images" v-bind:key="index" style="margin:unset; padding:unset"> -->
                        <img :src="image.source" style="width:100%">
                      </md-board>
                    </md-boards>
                  <!-- <linkinfo v-if="userDetails.beta && (userDetails.sensitiveContent && link.adult) || link.info" :adult="link.adult" :info="link.info" /> -->
                  <linkinfo v-if="link.adult || link.info || link.password" :link="link" :compact="userDetails.compactLinks" isSlinkView=true />
                    <md-divider></md-divider>
                  </md-list-item>

                  <!-- <md-list-item v-else class="imageSlink" style="margin:0px;width:100%;max-width:100%;"> -->
                    <div v-else class="9cube links" :class="{floating: userDetails.floating, gallery9cube: userDetails.floating, bottomBorder: !userDetails.floating}" v-bind:style="{background: fullColourButtons(link.background)}" style="width:100%; display:flex; flex-wrap:wrap;justify-content: start;">
                      <!-- <img v-for="(image, index) in getGallery(link.user)" v-bind:key="index" :src="imageKit(image)" style="object-fit:cover;width:33.33%;" :id="'galleryThumb' + index" v-bind:style="{ height: mediaHeight('galleryThumb'+index, 'galleryThumb', link.user) }" @click="openImage()"> -->
                      <div v-if="link.description" style="font-size:16px; padding:8px 16px; width:100%">
                        <div style="width:100%; font-weight:bold;" v-html="link.description"></div>
                        <div v-if="link.customdescription" style="font-size:14px; width:100%" v-html="link.customdescription"> </div>
                      </div>


                      <div :class="{gallery9cubeBorder: userDetails.floating}" style="width:100%; display:flex; flex-wrap:wrap;justify-content: start; " v-bind-style="{background: link.background}">
                        <div v-if="link.title" style="width:100%; font-weight:bold; font-size:16px; padding: 5px 20px; " v-bind:style="{color:link.color}">{{link.title}}</div>
                        <img v-if="link.linkOnly == true" v-for="(image, index) in link.images" v-bind:key="index" :src="imageKit(image.source,'9cubethumb')" style="object-fit:cover;width:33.33%;" :id="'9cubeThumb' + index" @click="gTravel(image.url,'',''), gaLoggedSlinkClink([$route.params.uid], link.id, link.site)" v-bind:style="{ height: mediaHeight('9cubeThumb'+index, 'galleryThumb', image.source) }" >
                        <!-- <img v-if="link.linkOnly == true" v-for="(image, index) in link.images" v-bind:key="index" :src="imageKit(image.source,'9cubethumb')" style="object-fit:cover;width:33.33%;" :id="'9cubeThumb' + index" v-bind:style="{ height: mediaHeight('9cubeThumb'+index, 'galleryThumb', image.source) }" @click="gTravel(image.url,'',''), gaLoggedSlinkClink([$route.params.uid], link.id, link.site)"> -->
                        <img v-if="link.linkOnly == false || link.linkOnly == undefined" v-for="(image, index) in link.images" v-bind:key="index" :src="imageKit(image.source,'9cubethumb')" style="object-fit:cover;width:33.33%;" :id="'9cubeThumb' + index" v-bind:style="{ height: mediaHeight('9cubeThumb'+index, 'galleryThumb', image.source) }" @click="openImage(image)">
                        <!-- <p v-for="(imagea, index) in link.images" v-bind:key="index"><span v-if="imagea.description !=undefined">{{imagea.description}}</span></p> -->
                      </div>
                    </div>
                    <!-- <md-divider></md-divider> -->
                  <!-- </md-list-item> -->
                </div>


                <!-- <div v-else-if="(isAllowed(7)) && link.site == 'HTML'">
                  <md-list-item  style="margin:0px;width:100%;max-width:100%;">
                    <md-avatar v-if="!userDetails.showIcons" class="md-large" v-bind:class="{pulse: (link.pulse && (isAllowed(7)))}" v-bind:style="{ color: link.color, background: link.background }" style="border-width: 1px; border-color: silver; border-style: solid;text-align: center;">
                      <i v-if="(link.fa && !link.favicon)" class="fa fa-fw fa-2x" v-bind:style="{ color: link.color, background: link.background }" v-bind:class="'fa-'+link.fa" aria-hidden="true" style="padding-top:16px"></i>
                      <img v-if="link.favicon && link.faviconFull == 1" v-bind:src="link.favicon" v-bind:id="link.site" @error="failedIcon"/>
                      <img v-if="link.favicon && link.faviconFull != 1" v-bind:src="link.favicon" v-bind:id="link.site" style="height:32px; width:32px; margin-left: auto; margin-right: auto; margin-top: 16px;" @error="failedIcon"/>
                    </md-avatar>
                      <div v-if="link.info" style="border-radius: 0px 0px 0px 10px; right: 0px; position: absolute; top: 0px; line-height: 20px; font-size: 10px; background-color: grey; color: white; max-height: 30px; padding-left: 5px; padding-right: 5px;">{{link.info}}</div>

                    <div class="md-list-text-container" v-bind:style="textAlign">
                      <h3>
                        <span v-if="link.description">{{ link.description }}</span>
                        <span v-else>{{link.site}}</span>
                      </h3>
                      <span style="position: relative;top: -16px; white-space: pre-wrap;">{{ link.customdescription }}</span>
                    </div>
                  

                    <md-list-expand style="margin:0px;width:100%;max-width:100%;">
                      <span v-html="link.user"></span>
                      <md-divider></md-divider>
                    </md-list-expand>
                  </md-list-item>
                </div> -->

                <!-- QUICKLINKS -->
                <div class="links quicklinksBar" v-else-if="(isAllowed(7)) && link.site == 'QuickLinks' && quicklinks.length != 0" style="" v-bind:style="{background: link.background}, link.styling" v-bind:class="{qlbTransparent: link.transparent, iconStyle0 : userDetails.iconStyle == 0, iconStyle2 : (userDetails.iconStyle==2 || userDetails.iconStyle == 1), ['style'+userDetails.iconStyle]:true}">
                  <div v-for="(qlink, index) in quicklinks" v-bind:key="index" style="width: calc(100% / 6)" @click="gTravel(qlink.base, qlink.user, qlink.suffix), gaLoggedSlinkClink([$route.params.uid], qlink.id, qlink.site)" class="quickLinkButton" v-bind:style="link.qlStyling">
                      <siteicon v-bind:class="{quickLinksIconStyle2 : (userDetails.iconStyle==2 || userDetails.iconStyle==1)}" :account="parseInt(userDetails.account)" :enableUpgrades="userDetails.enableUpgrades" :link="qlink" compact isQuicklink />
                  </div>
                </div>
                

                <!-- HISTORICAL -->
                <md-list-item class="imageSlink links" v-else-if="(isAllowed(7)) && link.site == 'In-Line Embed'" style="display:inline-flex;margin:0px;width:100%;max-width:100%;display:flex" v-bind:style="{background: fullColourButtons(link.background)}">
                    <iframe v-bind:style="{'min-height': link.height}" width="100%" :src="embedLink(link.user, link.site)" frameborder="0" allow="autoplay; encrypted-media" style="background:black;width:100%;height:30vh"></iframe>
                </md-list-item>

                <links v-else-if="getSlinkCanInLine(link.site) && link.site!='Link Group'" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)" />
                <!-- <links v-else-if="link.site == 'Embed'" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)" /> -->
                      <!-- <div v-else-if="link.site == 'Embed'"> test</div> -->


                <links v-else-if="link.site == 'Embed'" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)" />

                <!-- <div v-else-if="(isAllowed(7)) && !link.inline && link.site == 'Link Group'" :id="'section_'+link.id" class="links grouped" v-bind:style="{background: link.background0}" style="display:block;margin:0px;width:100%;max-width:100%">
                  <links v-if="link.title != false" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)" />
                  <links v-for="(groupLink, index) in inGroup(link.id)" v-bind:key="index"  :link="groupLink" :user="userInfo" :linkFormatting="linkFormatting(groupLink.site)" :class="{'shake': groupLink.shake}" />
                </div> -->
                


                <md-list-item class="links standardLink linksWithExpand" v-else-if="(isAllowed(7)) && link.site != 'QuickLinks'" style="display:inline-flex;min-height:unset; margin:0px;width:100%;max-width:100%;" @click="setActiveVideoPlayer(index);gaLoggedSlinkClink([$route.params.uid], link.id, link.site)" v-bind:style="{background: fullColourButtons(link.background)}" v-bind:class="{compactLinks: userDetails.compactLinks, iconStyle1: userDetails.iconStyle == 1, iconStyle2: userDetails.iconStyle==2}">
                  <siteicon v-if="!userDetails.showIcons && (link.favicon || link.fa)" :account="parseInt(userDetails.account)" :enableUpgrades="userDetails.enableUpgrades" :link="link" :compact="userDetails.compactLinks" :iconStyle="userDetails.iconStyle" />
                  <linkinfo v-if="link.adult || link.info || link.password" :link="link" :compact="userDetails.compactLinks" isSlinkView=true style="z-index:1" />
                  <div class="md-list-text-container" v-bind:style="textAlign" v-bind:class="{hideIconEmbed : userDetails.showIcons}" style="margin-top:8px; margin-bottom:8px;">
                    <h3 style="white-space:normal; margin:unset" v-bind:style="{ fontSize: userDetails.customFontSize, fontWeight: userDetails.customFontWeight, lineHeight: userDetails.customLineHeight }">

                      
                      <span style="white-space:inherit" v-if="link.description && link.site=='Link Group'" :id="'section_'+link.id" v-bind:style="{background: fullColourButtons(link.background), color: fullColourButtonsText(link.background, link.ForceTextColour, link.color), color:link.color}" v-html="link.description"></span>
                      <span style="white-space:inherit" v-else-if="link.description" v-bind:style="{color: fullColourButtonsText(link.background, link.ForceTextColour, link.color)}" v-html="link.description"></span>
                      <span style="white-space:inherit" v-else v-bind:style="{color: fullColourButtonsText(link.background, link.ForceTextColour, link.color)}">{{link.site}}</span>
                    </h3>
                    <span v-bind:style="{color: fullColourButtonsText(link.background, link.ForceTextColour, link.color)}" style="position: relative; white-space: pre-wrap;">{{ link.customdescription }}</span>
                  </div>
                  <!-- <md-icon v-if="link.password" class="md-primary">locked</md-icon> -->
                  <md-list-expand style="background:none">
                    <div v-if="link.password && (link.password != linkPasswords[link.id])" style="padding:10px 24px;font-weight:bold; text-align:center">
                      The content is password protected.
                      <md-input-container md-has-password style="max-width:75%;margin-right: auto;margin-left: auto;">
    <label>Password</label>
    <md-input v-model="linkPasswords[link.id]" type="password"></md-input>
  </md-input-container>
                    <md-divider></md-divider>

                      </div>

                                   
                  <div v-else>
                    <div v-if="link.site == 'Send Message'" width="100%" style="padding:10px">
                     <form novalidate @submit.stop.prevent="submit">
                      <md-input-container style="margin-left:10px; margin-right:10px; width:-webkit-fill-available">
                        <label>Email Address</label>
                        <md-input required type="email"></md-input>
                      </md-input-container>
                      <md-input-container style="margin-left:10px; margin-right:10px; width:-webkit-fill-available">
                        <label>Message</label>
                        <md-textarea required maxlength="500"></md-textarea>

                      </md-input-container>
                      <md-button style="width:-webkit-fill-available" class=" md-primary md-dense">Send</md-button>
                     </form>
                    </div>

                    <div v-else-if="link.site == 'Link Group'" style="display:block;margin:0px;width:100%;max-width:100%;">
                      <links v-for="(groupLink, index) in inGroup(link.id)" v-bind:key="index"  :link="groupLink" :user="userInfo" :linkFormatting="linkFormatting(groupLink.site)" />
                    </div> 

                    <div v-else-if="link.site == 'Text Block'" v-bind:style="{background: fullColourButtons('#ffffff')}" style="background-color:white;padding-top:10px; padding-bottom:10px;padding-left:20px; padding-right:20px; border-bottom:1px solid silver" v-html="link.user"></div>
                    <!-- <div v-else-if="link.site == 'Text Block'" v-bind:style="{background: fullColourButtons('#ffffff')}" style="background-color:white;padding-top:10px; padding-bottom:10px;padding-left:20px; padding-right:20px; border-bottom:1px solid silver" v-html="link.user"><md-divider></md-divider></div> -->
                    
                    <iframe :onload="mediaHeight(link.id, link.site, link.user)" :id="link.id" :ref="link.id" v-else-if="activeVideo == index" v-bind:style="{'height': embedLinkHeight(link.id, link.user)}" width="100%" :src="embedLink(link.user, link.site)" frameborder="0" allow="autoplay; encrypted-media" style="min-height:30vh; width:100%; background:white"></iframe>
                    
                    <table v-else-if="link.site == 'List'"  style="width:100%;border-spacing: unset">
                      <thead v-if="link.inline">
                        <tr>
                          <th v-if="link.description" colspan=2>{{link.description}}</th>
                          <th v-else colspan=2>{{link.site}}</th>
                        </tr>
                        <tr v-if="link.customdescription">
                          <th colspan=2>{{link.customdescription}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(listItem, index) in listOrder(link.list)" v-bind:key="index" v-if="listItem">
                          <th style="width:35%; padding-left:20px">{{listItem.item}}</th><td style="padding-right:20px">{{listItem.value}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <md-divider></md-divider>
                </md-list-expand>
                <md-divider></md-divider>
              </md-list-item>
            <!-- </div> -->
          </div>

               
            <!-- TEMPLATE LINKS END -->
            <div v-if="templateLinks && templateLinks.below" class="templateBelow" :class="{'floating': userDetails.floating}">
              <links class="slinkItems" v-for="(link, index) in templateLinks.below" v-bind:key="'below'+index" :link="link" :user="userInfo" :linkFormatting="linkFormatting(link.site)" :class="{'shake': link.shake, 'linkBorder': userDetails.linkBorder && userDetails.floating}"/>
            </div>

            <!-- ADVERTS / SUGGESTED PAGES -->
            
            <!-- <md-list-item class="links slinkItems" v-if="randomAd && randomAd.adNetwork != true && randomAd.title != 'Google AdSense' && randomAd.title != 'Sona' && randomAd.title != 'Suggested Slink Pages' && !randomAd.banner && !(randomAd.adult && this.userDetails.adult && this.visitorAge == false ) && randomAd.sticky != true" v-bind:href="randomAd.url" target="blank" style="background:white; margin:0px;width:100%;max-width:100%; " @click="gaLoggedSponsored(userDetails.url, randomAd)">
              <md-avatar class="md-large" style="border-width: 1px; border-color: silver; border-style: solid;text-align: center;">
                <img v-bind:src="userContentCDN(randomAd.favicon)" style="object-fit:cover"/>
              </md-avatar>
                <div class="md-list-text-container">
                <h3 style="white-space:normal"><span style="white-space:normal">{{randomAd.title}}</span></h3>
                <span style="position: relative;top: -16px; white-space: unset;">{{randomAd.description}}</span>
              </div>
              <div style="border-radius: 0px 0px 0px 10px; right: 0px; position: absolute; top: 0px; line-height: 20px; font-size: 10px; font-weight:bold; background-color: grey; color: white; max-height: 30px; padding-left: 10px; padding-right: 5px;">
                <span v-if="randomAd.fsp">Featured Slink Page</span>
                <span v-else>Ad</span>
              </div>
              <div v-if="randomAd.tracker"><img border="0" width="1" alt="" height="1" v-bind:src="randomAd.tracker" ></div>
              <md-divider></md-divider>
            </md-list-item> -->

          <!-- <div v-if="randomAd && randomAd.title == 'Sona'" class="slinkItems" style="position:relative; display:flex; background:whitesmoke" @click="gaLoggedSponsored(userDetails.url, randomAd)">
            <div style="border-radius: 0px 0px 0px 10px; right: 0px; position: absolute; top: 0px; line-height: 20px; font-size: 10px; font-weight:bold; background-color: grey; color: white; max-height: 30px; padding-left: 10px; padding-right: 5px;">
                <span>Ad</span>
              </div>
            <sona-widget auto-scale style="width:100%"></sona-widget>
            </div> -->
            <!-- <div v-else-if="randomAd && randomAd.title == 'PurpleAds'" id='purpleAdsContainer' class="slinkItems" data-pa-tag style="min-width:300px;min-height:100px">
              </div> -->

              <!-- <div v-else-if="randomAd && randomAd.adNetwork && randomAd.title == 'JuicyAds'" id='JuicyAdsContainer' class="slinkItems" style="background:#696969; min-width:300px;min-height:100px; display:grid; justify-content:center">
                <div style="z-index:200; border-radius: 0px 0px 0px 10px; right: 0px; position: absolute; top: 0px; line-height: 20px; font-size: 10px; font-weight:bold; background-color: grey; color: white; max-height: 30px; padding-left: 10px; padding-right: 5px;">
                <span>Ad</span>
              </div>
                <ins id="938746" data-width="450" data-height="100" style="width:100% !important"></ins>
              </div> -->

              <!-- <div v-else-if="randomAd && randomAd.title == 'PurpleAds'"><div data-pa-tag></div> -->
                <!-- <div><script src="https://cdn.prplads.com/agent.js?publisherId=03b3a053959fb5bdbc814a9686ec4796:7fe5d842714456e1b31b7971ea7cbf1faf8e6230d35934b8aecba1a859995e63c7048e3db35bbd6f41d77211c3ef81339a44e66c851f3140cb3282f16ca66149" data-pa-tag async></script></div> -->
              <!-- </div> -->




            <!-- <div v-else-if="randomAd && randomAd.title == 'Google AdSense'" id="googleAdContainer" class="slinkItems" style="position:relative; display:flex; justify-content:center; background:whitesmoke;width:100%;max-height:300px;overflow:hidden"> -->
              
<!-- <ins id="googleAd" class="adsbygoogle "
     style="display:inline-block;background:whitesmoke;min-height:50px; min-width:300px; min-height:100px" 
     data-ad-client="ca-pub-4851595799020695"
     data-ad-slot="3345207231"
     @click="gaLoggedSponsored(userDetails.url, randomAd)"> -->
     <!-- <div style="z-index:1;border-radius: 0px 0px 0px 10px; right: 0px; position: absolute; top: 0px; line-height: 20px; font-size: 10px; font-weight:bold; background-color: grey; color: white; max-height: 30px; padding-left: 10px; padding-right: 5px;">
                <span>Ad</span>
              </div> -->
     <!-- <a v-if="userDetails.adult" href="https://www.lovense.com/r/0sgpzs"><img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/ads%2FLush%203.jpg.png?alt=media&token=0f308f56-de00-4d3f-9b3c-f605e07d3050"></a> -->
     <!-- <a v-if="userDetails.adult" href="http://fancentro.com/r/3TMM8cMk"><img src="https://ht-st.centrofiles.com/fc/og-tags/og_image_home.png"></a> -->
     <!-- <a v-else href="https://nexo.io/ref/ktmkhsvjad?src=web-link"><img src="https://nexo.io/media/pages/ref/015a7272ed-1653581658/ref-meta.jpg"></a> -->



     <!-- </ins> -->

     <!-- <ins class="adsbygoogle"
     style="display:block"
     data-ad-client="ca-pub-4851595799020695"
     data-ad-slot="6424712436"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins> -->
     <!-- </div> -->
     
           


            <a v-else-if="randomAd && randomAd.title != 'Suggested Slink Pages'  && randomAd.sticky != true && randomAd.banner && !(randomAd.adult && this.userDetails.adult && this.visitorAge == false )" class="bannerAd links slinkItems" v-bind:href="randomAd.urls != undefined ? randomAd.urls[Math.floor(Math.random() * (randomAd.urls.length))] : randomAd.url" target="blank" style="position:relative; background:white;padding:0px; margin:0px;width:100%;max-width:100%; " @click="gaLoggedSponsored(userDetails.url, randomAd)">
              <div style="border-radius: 0px 0px 0px 10px; right: 0px; position: absolute; top: 0px; line-height: 20px; font-size: 10px; font-weight:bold; background-color: grey; color: white; max-height: 30px; padding-left: 10px; padding-right: 5px;"> 
                <span v-if="randomAd.fsp">Featured Slink Page</span>
                <span v-else>Ad</span>
              </div>
              <img v-if="!randomAd.images" :src="userContentCDN(randomAd.favicon)" style="width:100%"/>
              <img v-else :src="userContentCDN(randomAd.images[Math.floor(Math.random() * (randomAd.images.length))])" style="width:100%"/>
              
              <div v-if="randomAd.tracker"><img border="0" width="1" alt="" height="1" v-bind:src="randomAd.tracker" ></div>  
            </a>

            <md-list-item class="links slinkItems" v-else-if="randomAd && randomAd.title == 'Suggested Slink Pages'" style="background:white; margin:0px;width:100%;max-width:100%; padding:0 0px" @click="getSuggestedPages, openDialog('suggestedPagesDialog'); ">
              <md-avatar class="md-large" style="border-width: 1px; border-color: silver; border-style: solid;text-align: center;">
                <img loading="lazy" v-bind:src="userContentCDN('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F3hXX2lTHANdiDOU4GxBy3zWaKyu2%2Fprofile?alt=media&token=02932fb0-3c72-4845-8ad9-8a9799f8367a')" style="object-fit:cover"/>
              </md-avatar>
              <div class="md-list-text-container">
                <h3 style="white-space:normal"><span style="white-space:normal">Similar Slink Pages</span></h3>
                <span style="position: relative;top: -16px; white-space: unset;">Explore pages that other visitors found interesting too.</span>
              </div>
              <md-divider></md-divider>
            </md-list-item>
            <!-- <md-list-item class="links slinkItems" v-if="userDetails.beta" style="background:white; margin:0px;width:100%;max-width:100%; " @click="getSuggestedPages, openDialog('suggestedPagesDialog'); ">
              <md-avatar class="md-large" style="border-width: 1px; border-color: silver; border-style: solid;text-align: center;">
                <img v-bind:src="userContentCDN('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F3hXX2lTHANdiDOU4GxBy3zWaKyu2%2Fprofile?alt=media&token=02932fb0-3c72-4845-8ad9-8a9799f8367a')" style="object-fit:cover"/>
              </md-avatar>
              <div class="md-list-text-container">
                <h3 style="white-space:normal"><span style="white-space:normal">Similar Slink Pages</span></h3>
                <span style="position: relative;top: -16px; white-space: unset;">Explore pages that other visitors found interesting too.</span>
              </div>
              <md-divider></md-divider>
            </md-list-item> -->

            <!-- ICE -->
            <!-- <md-list-item v-if="userDetails.ice" @click="gTravel('https://www.google.com/maps/dir/?api=1&destination=', userDetails.iceLocation.latitude, ', '+userDetails.iceLocation.longitude)">
              {{iceLocation}}
            </md-list-item> -->

          <div v-if="!userDetails.socialShare" class="socialShare links slinkItems" v-bind:style="{background: fullColourButtons(userDetails.socialShareColour, 'socialShare'), color:fullColourButtonsText(userDetails.socialShareColour, userDetails.socialShareTextForce, userDetails.socialShareTextColour,'socialshare')}" style="height:42px; justify-content: center; display: flex; align-content: center;
    align-items: center; backdrop-filter:blur(2px)"  v-bind:class="{clear: userDetails.clearLinks, flat:userDetails.flat, linkBorder:userDetails.linkBorder && userDetails.floating}">
            <span style="font-size:small;" >Share:</span>
            <md-button class="md-icon-button md-dense shareIcon" target="_blank" @click="webShare(); gGALog(userDetails.url, 'Social Share', 'WebShare')">
              <md-icon style="font-size:small" md-iconset="fa fa-fw fa-share-alt"></md-icon>
            </md-button>
            <!-- <md-button v-if="!isMobile && (userDetails.share == undefined || !userDetails.share.facebook == false)" class="md-icon-button md-dense shareIcon" target="_blank" @click="gGALog(userDetails.url, 'Social Share', 'Facebook')" v-bind:href="'https://www.facebook.com/sharer/sharer.php?u=https%3A//myslink.app/'+userDetails.url">
              <md-icon style="font-size:small" md-iconset="fa fa-fw fa-facebook"></md-icon>
            </md-button> -->
            <!-- <md-button v-if="!isMobile && (userDetails.share == undefined || !userDetails.share.twitter == false)" class="md-icon-button md-dense shareIcon" target="_blank" @click="gGALog(userDetails.url, 'Social Share', 'Twitter')" v-bind:href="'https://twitter.com/intent/tweet?text=Check%20out%20'+ userDetails.name+'%27s%20social%20media%20profiles%20and%20websites%20on%20their%20Slink%20Digital%20Business%20Card%20%0Ahttps%3A//www.myslink.app/'+userDetails.url">
              <md-icon style="font-size:small" md-iconset="fa fa-fw fa-twitter"></md-icon>
            </md-button> -->
            <!-- <md-button v-if="!isMobile && (userDetails.share == undefined || !userDetails.share.whatsapp == false)" class="md-icon-button md-dense shareIcon" target="_blank" @click="gGALog(userDetails.url, 'Social Share', 'WhatsApp')" v-bind:href="'https://api.whatsapp.com/send?text=Check%20out%20'+ userDetails.name+'%27s%20social%20media%20profiles%20and%20websites%20on%20their%20Slink%20Digital%20Business%20Card%0Ahttps%3A%2F%2Fmyslink.app%2F'+userDetails.url+'&phone='">
              <md-icon style="font-size:small" md-iconset="fa fa-fw fa-whatsapp"></md-icon>
            </md-button> -->
            <!-- <md-button v-if="!isMobile && (userDetails.share == undefined || !userDetails.share.email == false)" class="md-icon-button md-dense shareIcon" target="_blank" @click="gGALog(userDetails.url, 'Social Share', 'Email')" v-bind:href="'mailto:?subject=Slink:%20My%20Digital%20Business%20Card&body=Check%20out%20'+ userDetails.name+'%27s%20social%20media%20profiles%20and%20websites%20on%20their%20Slink%20Digital%20Business%20Card%0Ahttps%3A%2F%2Fmyslink.app%2F'+userDetails.url">
              <md-icon style="font-size:small" md-iconset="fa fa-fw fa-envelope-o"></md-icon>
            </md-button> -->
            <md-button class="md-icon-button md-dense shareIcon" @click="openDialog('qrcodeDialog'); gGALog(userDetails.url, 'Social Share', 'QR Code')">
              <md-icon style="font-size:small" md-iconset="fa fa-fw fa-qrcode"></md-icon>
            </md-button>
            <md-button type="submit" class="md-icon-button md-dense shareIcon" @click="downloadvCard(); gGALog(userDetails.url, 'Social Share', 'vCard Download')">
              <md-icon style="font-size:small" md-iconset="fa fa-fw fa-cloud-download"></md-icon>
            </md-button>
            <div style="text-align:center">
              <md-button class="md-icon-button md-dense shareIcon" style="margin-right:5px" @click="copy('https://MySlink.app/'+userDetails.url); gGALog(userDetails.url, 'Social Share', 'Copy to Clipboard')" >
                <md-icon style="font-size:small" md-iconset="fa fa-fw fa-clipboard"></md-icon>
              </md-button>
            </div>
          </div>
        <!-- </md-list> -->
        </div>
      <!-- </md-whiteframe> -->

      <!-- <div v-if="userDetails.verifiefDisplay" style="font-weight:bold;font-size:x-small; text-align:center; line-height:initial; padding:20px 52px" v-bind:style="{color: fullColourButtonsText(userDetails.background2,null, null,'footer')}">The owner of this Slink page has been verified using official government-issued identification documents to confirm their identity.</div> -->


      <div v-if="userDetails.albumPlayer" class="stickyFooter albumPlayer" style="height:auto; " >
        <div class="controls">
        <!-- <div v-if="albumPlayer" style="background:black; color:white; padding: 5px 0; width:100%; font-weight:bold;text-align:center">{{ albumPlayer.title }}</div> -->

          <div style="display:flex; gap:5px; color:white;padding:0px 10px; align-items:center; flex-direction:column">
            
            <md-progress class="md-accent" :md-progress="playerProgress"></md-progress>
            
            <div style="width:100%;display:flex; align-items:center; gap:5px;">

              <div style="font-size: smaller; width:30px; width: 30px; text-align: left;">{{ convertTimeHHMMSS(player.current) }}</div>
              <!-- <div style="display:flex; flex-direction: column; width:-webkit-fill-available;"> -->
                <!-- <md-progress class="md-accent" :md-progress="playerProgress"></md-progress> -->
                    <div style="flex-grow:1">
                      <!-- <md-button class="md-icon-button md-dense" @click="playAudio()">
              <md-icon>play_arrow</md-icon>
            </md-button> -->
            <div v-if="albumPlayer" style="text-align:center; width:100%; font-size:smaller; background:black; color:white; padding: 0px 0; width:100%; font-weight:bold; overflow: hidden;white-space:nowrap; text-overflow: ellipsis;">{{albumPlayer.index + 1 }}. {{ albumPlayer.title }}</div>
            <div v-else="albumPlayer" style="text-align:center; width:100%; font-size:smaller; background:black; color:white; padding: 0px 0; width:100%; font-weight:bold; overflow: hidden;white-space:nowrap; text-overflow: ellipsis;">loading...</div>
          </div>
              <!-- </div>   -->
              <div style="font-size: smaller; width: 35px; text-align: right;">{{ convertTimeHHMMSS(player.duration) }}</div>
            </div>
            
            
          </div>
          <div style="display:flex; justify-content: center;">
            <md-button class="md-icon-button md-dense" @click="playAudio()">
              <md-icon>skip_previous</md-icon>
            </md-button>
            <md-button class="md-icon-button md-dense" @click="playAudio()">
              <md-icon>play_arrow</md-icon>
            </md-button>
            <md-button class="md-icon-button md-dense" @click="playAudio()">
              <md-icon>skip_next</md-icon>
            </md-button>
          </div>
        </div>
       
        <audio id="albumPlayer" controls controlsList="nodownload noplaybackrate " v-on:loadeddata="playerLoaded" v-on:timeupdate="playerUpdate" style="display:none; padding:5px;height:55px; width: 100%;">
  <!-- <source v-if="albumPlayer" type="audio/mpeg"> -->
  <!-- <source src="horse.mp3" > -->
  Your browser does not support the audio tag.
</audio>
      </div>


      <div v-if="(userDetails.footer == undefined ||  userDetails.footer || userDetails.claim) && userDetails.showFooter != false" class="" v-bind:class="{stickyFooter: (userDetails.stickyFooter)}" style="font-family: 'GoogleSans'; width:100%; text-align:center;">
        <div v-if="userDetails.claim" style="font-family: 'GoogleSans'; text-align: center; font-weight: bold; padding: 5px; font-size: smaller;" @click="openDialog('signupDialog')">CLAIM THIS SLINK PAGE</div>
        <div v-else-if="(isAllowed(7)) && userDetails.customFooter" @click="gGALog(userDetails.url, 'Footer Click', 'Footer')" style="width:100%; text-align:center;font-size:1.25em;color:gray;margin-top:0px;">
        <div v-if="userDetails.parentLogo" style="width:100%; display:flex;flex-flow: column;align-items: center;">
          <a v-bind:href="userDetails.parentFooterURL" target="_blank">
            <img style="width:128px" :src="userDetails.parentLogo" />
            <div v-if="userDetails.parentFooterText" style="font-weight:bold">{{userDetails.parentFooterText}}</div> 
          </a>
        </div>
          <router-link v-bind:to="'/?utm_source='+ profile['.key'] +'&utm_medium=Footer'" class="" style="color:gray; width:100%">
            <div v-if="userDetails.customFooter" style="vertical-align: middle; font-size: x-small; text-transform: uppercase;" v-html="userDetails.customFooter"></div>
            <!-- <span v-else style="vertical-align: middle; font-size: x-small; text-transform: uppercase;">Get your own Slink page</span> -->
          </router-link>
        </div>
        <div v-else style="width: 100%; font-size: x-small; font-weight:bold; text-align: center; line-height: 15px; padding-top:20px;padding-bottom:20px;">
          <div @click="openDialog('signupDialog')" class="" style="width:100%" v-bind:style="{color: fullColourButtonsText(userDetails.background2,null, null,'footer')}">
            Made with ❤️ by Slink<span v-if="!userDetails.discreetBranding" style="font-weight: normal; line-height: ;"><br>Get your own free Slink page!</span>
          </div>
        </div>
      </div>

    <!-- </md-layout> -->
      <!-- <md-layout md-hide-xsmall md-flex-small="25" md-flex-medium="25" md-flex-large="35" md-flex-xlarge="33"><div></div></md-layout> -->
<!-- <div class="spacer"></div> -->
  <!-- </md-layout> -->
  <!-- </div> -->
  </div>
  <!-- <div v-if="referrerIG">IG</div> -->
    
  <md-dialog-alert :md-title="qrcode.title" :md-content-html="qrcode.contentHtml" ref="qrcodeDialog" class="qrDialog">
  </md-dialog-alert>

  <md-dialog ref="suggestedPagesDialog" style="border-radius:15px;" class="qrDialog">
    <md-dialog-title>Similar Slink Pages</md-dialog-title>
    <md-dialog-content>
      <div v-if="Object.keys(suggestedPages).length == 0" style="display:flex; flex-flow:column">
        <div>Loading...</div>
        <md-progress class="md-accent" md-indeterminate></md-progress>
      </div>
      <div style="display: grid; gap: 10px; grid-template-columns: repeat(3, calc((100% - 20px) / 3)); width: 100%; padding:10px 0">
        <div v-for="(suggestion, index) in suggestedPages" v-bind:key="index"  v-bind:class="{premiumSuggestion: suggestion.promotedSP, pulse: suggestion.promotedSP}" style="background: whitesmoke;border-radius: 10px;width: 100%;text-align: center;overflow: hidden;border:silver 1px solid;">
          <img :alt="suggestion.views" :src="suggestion.picture" @click="gTravel('https://www.myslink.app/',suggestion.url,'?utm_source=slink&utm_medium=suggestedpages&utm_campaign='+[$route.params.uid]), gaLoggedSuggested([$route.params.uid], suggestion.url);" style="object-fit: cover; object-position: center;border-radius:0px; width:100%; aspect-ratio:1/1;" />
          <div style="overflow-wrap: anywhere;padding:4px;text-transform: uppercase;font-weight:bold; font-size:x-small; line-height:normal">{{suggestion.name }}</div>
        </div>
      </div>  
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary" @click="gCloseDialog('suggestedPagesDialog')">Close</md-button>
    </md-dialog-actions>
  </md-dialog>

  <md-dialog class="imageDialog" md-open-from="#fab" md-close-to="#fab" ref="imageDialog" style="border-radius:15px;" @close="imageDialogClose">
    <md-dialog-content style="padding: 0 24px 0 24px">
      <figure style="margin: unset;">
        <img :src="currentImage"  @click="gTravel(currentImageURL,'',''), gaLoggedSlinkClink([$route.params.uid], 'Gallery', 'Gallery')" style="height:100%; object-fit:contain"/>
        <figcaption v-if="currentImageURL" style="text-align:center">
          <a :href="currentImageURL" target="_blank" style="text-decoration:none">
            {{currentImageDescription}}
            <md-icon class="md-primary" style="width: unset; min-width: unset; height: unset; min-height: unset; font-size: 16px;">launch</md-icon>
          </a>
        </figcaption>
        <figcaption v-else style="text-align:center">{{currentImageDescription}}</figcaption>
      </figure>
    </md-dialog-content>
  </md-dialog>

  <md-dialog class="signupDialog" ref="signupDialog" :md-backdrop=false>
    <md-dialog-content>
      <div style="display:flex;padding:0px 0 10px 0;font-weight: bold; font-size: 3em;line-height: 45px;margin:unset">
        <span>Create Account</span>
        <span style="flex-grow:1" />
        <md-button class="md-icon-button" style="margin:unset; border-radius:unset" @click="gCloseDialog('signupDialog')">
          <md-icon style="height:unset">close</md-icon>
        </md-button>
      </div>
      <div style="width: 100%; font-size: medium; line-height: initial;padding-bottom:10px">
        Sign up and to welcome you to our Family, we will send you discount code for your own Slink Card or Slink Sticker
      </div>
      <div class="slinkContainer" style="margin-top:10px;padding:10px 15px 0; border-radius:10px;">
        <p name="signupTitle" id="signupTitle" style="color:#000000; width:100%; text-align:center;font-size: 14px;">SIGN UP WITH EMAIL</p>
        <md-input-container style="margin-bottom: 5px;">
          <label>Email</label>
          <md-input style="font-size:18px !important" v-model="signupEmail" type="email" autocomplete="email" required></md-input>
        </md-input-container>
        <md-input-container md-has-password style="margin-bottom: 5px;">
          <label>Password</label>
          <md-input type="password" v-model="signupPassword" autocomplete="new-password" required></md-input>
        </md-input-container>
        <md-button :disabled="!(signupEmail && signupPassword)" style="width:100%" class="md-primary" @click="signupByEmail()">Sign Up</md-button>
      </div>
      <p style="margin: 5px; text-align:center">OR</p>
      <md-button @click="loginByGoogle()" class="md-raised googleBtn" style="margin:unset; width:100%; border-radius:10px"><img src="/static/images/home/googleg_color.png" style="font-size:16px;width:24px;margin-right:10px;margin-top:10px;margin-bottom:10px" />Sign Up with Google</md-button>
      <p STYLE="text-align:center; width:100%; font-size:smaller; text-align:center;margin-top:10px;">By registering a Slink account you are agreeing to our <a href="https://help.getsl.ink/article/terms-of-service/" target="_blank" style="text-decoration: underline; color: #000000;">Terms and Conditions</a> and <a href="https://help.getsl.ink/article/privacy-policy/" target="_blank" style="text-decoration: underline; color: #000000;">Privacy Policy</a></p>
      <router-link tag="md-button" to="/home" style="padding-top:20px; width:100%; border-radius:10px; margin:30px 0 0 0" class="md-primary">Learn more about Slink</router-link>
    </md-dialog-content>
  </md-dialog>

  <md-snackbar ref="snackbar" :md-duration="3600">
    <span>{{ notification }}</span>
    <md-button class="" @click="$refs.snackbar.close()">OK</md-button>
  </md-snackbar>

  <div v-if="userDetails.toolbarl" class="toolbar" style="position: fixed;
    border: 1px solid red;
    width: 100%;
    bottom: 0;
    height: 64px;
    background:#00000088">
    Toolbar
  
  </div>
  <!-- <div v-if="randomAd && randomAd.sticky" class="stickyAdvert slinkTtems" style="box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 5px 8px rgb(0 0 0 / 14%), 0 1px 14px rgb(0 0 0 / 12%);background:#ffffff77; max-height:50px !important; height:50px !important; width:100%; position: fixed; bottom: 0px;; margin-left:auto; margin-right:auto"> -->
    <!-- <div v-if="randomAd.title == 'Google AdSense Sticky'" style="background:#00000077; display:inline-block;width:100%;height:50px !important;max-height:50px !important" @click="gaLoggedSponsored(userDetails.url, randomAd)">
      <ins class="adsbygoogle"
        style="display:inline-block;width:100%;height:50px"
        data-ad-client="ca-pub-4851595799020695"
        data-ad-slot="9602621684" @click="gaLoggedSponsored(userDetails.url, randomAd)">
      </ins>
    </div> -->

    <!-- <div v-else-if="randomAd.title == 'Suggested Slink Pages'"  @click="getSuggestedPages; openDialog('suggestedPagesDialog');" style="background:#ffffff; max-height:50px; height:50px;display:flex; gap:10px">
                <img v-bind:src="userContentCDN('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F3hXX2lTHANdiDOU4GxBy3zWaKyu2%2Fprofile?alt=media&token=02932fb0-3c72-4845-8ad9-8a9799f8367a')" style="padding-left:10px;height:100%; object-fit:cover"/>
                <div>
                  <h3 style="white-space:normal; margin-top:6px">Suggested Slink Pages</h3>
                <span style="position: relative;top: -16px; white-space: unset;">Discover more Slink pages similar to this.</span>
                </div>
    </div> -->

    <!-- <a v-else class="" v-bind:href="randomAd.url" target="blank" style="height:50px; background:white;padding:0px; margin:0px;width:100%;max-width:100%; " @click="gaLoggedSponsored(userDetails.url, randomAd)">
              <div style="border-radius: 0px 0px 0px 10px; right: 0px; position: absolute; top: 0px; line-height: 20px; font-size: 10px; font-weight:bold; background-color: grey; color: white; max-height: 30px; padding-left: 10px; padding-right: 5px;">
                <span>Ad</span>
              </div>
              <img v-if="!randomAd.images" :src="userContentCDN(randomAd.favicon)" style="width: 100%;
    height: 50px;
    object-fit: cover;"/>
              <img v-else :src="userContentCDN(randomAd.images[Math.floor(Math.random() * (randomAd.images.length))])" style="width:100%"/>
              
            </a> -->





   <!-- </div> -->

  </div>
</template>

<script>
  import Firebase from 'firebase'
  import {fb} from './firebaseconfig'
  // import 
  let db = fb.database();
  import linkinfo from "./linkinfo_component";
  import siteicon from "./siteicon_component";
  import profileheader from "./profileheader_component";
  import links from "./link_component_v2";

  const remoteConfig = fb.remoteConfig();
//   remoteConfig.settings = {
// minimumFetchIntervalMillis: 3000,
//     // minimumFetchIntervalMillis: 3600000,
//   };
  remoteConfig.settings.minimumFetchIntervalMillis = 3600000;



  remoteConfig.ensureInitialized().then(() => {
    // console.log('remote config initialised')
  })
  .catch((err) => {
    console.error('Firebase Remote Config failed to initialize', err);
  });

  import Vue from 'vue'
  import VueAnalytics from 'vue-analytics'
// import { page } from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: ['UA-81938309-3', 'UA-81938309-4']
// })


  export default {
    name: 'SlinkView',
    components:{
      linkinfo,
      siteicon,
      profileheader,
      links
    },
    metaInfo () {
      // let links = [
      //   // { rel: 'stylesheet', href: 'https://fonts.cdnfonts.com/css/miso' },
      // ];
  //     let style = [{ cssText: 
  //      ` @font-face {
  // font-family: hostedFont; src: url(https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F-NtunfJ7_h7neo8YIHLJ%2FSimpsonfont%20DEMO.otf?alt=media&token=50ff93e1-5151-4c29-8690-d9d671d08248); }`, type: 'text/css' }];
      let meta = [
      ];

      let script = [

      ];

      let noscript = [

      ];

      // if (this.customFont) {
      //   this.metaLinks.push({ rel: 'stylesheet', href: this.customFont });
      // }
      if( this.adScript){
        script.push(this.adScript)
      }
      if( this.adScript){
        script.push(this.adCode)
      }

    return { link: this.metaLinks, meta: this.metaMeta, script: script, noscript: noscript };
    // return { link: this.metaLinks, meta: this.metaMeta, script: script, noscript: noscript , style: style};
      // return {
        
        //       script: [
        //   { innerHTML: "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '"+ this.gaCode +"');"},
        //   { innerHTML: "gtag('config', '"+ this.gaCode +"');"},
        //   // { innerHTML: "(adsbyjuicy = window.adsbyjuicy || []).push({'adzone':938746});"}
        //   // { src:'https://cdn.purpleads.io/load.js?publisherId=a781610f5bff888239016c50732d887b:3a7303d764ba518726107620423493cf7308b2feacbd2f1faaa6edd5ebaab76964d609f3963b54bf812bb8f221a0be37001d125c615257f0307630b1251f8447', id:'purpleads-client'}
        // ],
        // noscript: [
        //   { innerHTML: this.fbPixelNoScript }
        // ]
      // }
    },
    data () {
      return {
        audioPlayer: null,
        player:{duration: 0, current:0, progress: 0},
        playerProgress: 0,
        albumPlayer:null,
        metaLinks: [],
        metaMeta: [],
        referrer: document.referrer,
        adScript: null,
        adCode: null,
        adsenseContent: null,
        adsenseScript: null,
        treasureHuntStatus: [],
        // userInfo:null,
        // pageTitle: this.getPageTitle,
        // juicyL: app.juicyLoaded,
        sonaClientId: this.getSonaClientID,
        // purpleAdsScript: null,
        sonaScript:null,
        sonaInit: null,
        // tiktokScript: null, 
        // igScript: null,
        // gumroadScript: null,
        // twitterScript:null,
        // openseaScript: null,
        signupEmail: null, 
        signupPassword: null,
        notification: '',
        isDev: false,
        isLocal: false,
        linkPasswords: [],
        randomAd: null,
        customFont: null, 
        fbPixel: null,
        fbPixelNoScript:null,
        gaScript: null,
        gaCode: null,
        activeVideo:null,
        userDetails:null,
        autopilotValid: true,
        hop: false,
        qrcode: {
          title: 'Slink QR Code',
          contentHtml: 'qrcode'
        },
        gallery: null,
        currentImage: null,
        currentImageDescription: null,
        currentImageURL:null,
        visitorAge:null,
        withCard: false,
        country: null,
        profile: null,
        suggestedPages: [],
        prioritySP:[],
        diagnostics:[],
        template:null,
        documentReferrer: null,
        userUID: null,
        AsyncHero: null,
        loadedSections: {},
      }
    },
    async created() {
    // beforeCreate() {
      // console.log('ios troubleshooting')
      this.$ga.page(this.$router)
      let self = this

      this.isDev = window.location.href.indexOf('slinkdev') != -1 ? true : false
      this.isLocal = window.location.href.indexOf('localhost') != -1 ? true : false

      await this.fetchUserProfile();
      await this.handleHopLinks();
      const { autopilot, warning, autopilotURL } = this.profile;
      this.autopilotValid = autopilot && autopilotURL && !warning;
      if (this.autopilotValid) {
        // db.ref(`users/${this.userUID}/pageViews`).transaction(currentValue => (currentValue || 0) + 1);
        // pageViews: Firebase.database.ServerValue.increment(1)

        this.gGALog(this.$route.params.uid.toLowerCase(), 'AutoPilot', autopilotURL);
        window.location.replace(autopilotURL);
      }
      this.setPageTitle();
      
      this.loadCustomFont()
      this.loadHostedFont()

      await this.getAdvert();

      if(!this.isDev && !this.isLocal){
        db.ref('users/' + this.userUID).update({
          // similarPages: self.profile.similarPages,
          pageViews: Firebase.database.ServerValue.increment(1)
        });
      }

      if( !this.isLocal ){
        // self.updateVisit(this.userUID)
      }
      // self.getSuggestionnv2(this.userUID)

      if(this.$route.params.ticket != undefined){
        this.profile.ticketNumber = this.$route.params.ticket
        console.log('Ticket', this.profile.ticketNumber)
      }
      if(this.profile.webhookURL){
        console.log('this page has a webhook alert', this.profile.webhookURL, '#' + document.referrer +'#', navigator)
        let slinkJSON = {
          'url': this.profile.url,
          'referrer': document.referrer
        }
        
        fetch(this.profile.webhookURL,
      // fetch("../api/exportAudience",
      {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        credentials: "same-origin",
        mode: "no-cors",
        method: "POST",
        body: JSON.stringify( slinkJSON )
      })
          // .then(res => res.json())
          .then(res => console.log(res));
      }

      const { mailjetID, parent, adult, account, url } = this.profile;
      if (mailjetID !== undefined || parent !== undefined) {
        if (adult) {
          this.gUpdateProperty('mjProperty/adult', true, this.userUID, this.userUID, `${url} (Slinkview)`);
        }
        if (parseInt(account) === 7 || parent) {
          this.gUpdateProperty('mjProperty/premium', true, this.userUID, this.userUID, `${url} (Slinkview)`);
        }
      } else if (mailjetID === undefined && parent === undefined) {
        db.ref('tasks/').push({ 'task': 'unsubscribe', 'uid': this.userUID, 'completed': false });
      }

      // if(!this.profile.mailjetID && this.profile.email){
      //   db.ref('users/'+ this.userUID +'/getmailjetid').transaction(function (current_value) {
      //     return this.profile.email;
      //   });
      // }

      //TREASURE HUNT
      if(self.profile.treasureHunt){

        try{
        this.treasureHuntStatus = JSON.parse(localStorage.getItem("treasureHunt"));
        console.log('getting local storage',this.treasureHuntStatus)

          for(var x in this.profile.links){
          if(this.profile.links[x].site == 'Treasure Hunt'){
            // console.log('found teasure hunt')
            for(var y in this.profile.links[x].quiz){
              this.profile.links[x].quiz[y].answered =  this.treasureHuntStatus[y]
            }
            console.log(this.profile.links[x].quiz)
          }
        }
        }
        catch(e){}
      }

      // if(this.profile.autopilot && this.profile.warning != true){
      //   // self.profile.autopilotValid = self.profile.autopilot && self.profile.autopilotURL
      //   this.autopilotValid = this.profile.autopilot && this.profile.autopilotURL
      //   if(this.autopilotValid){
      //     db.ref('users/'+ this.userUID +'/pageViews').transaction(function (current_value) {
      //       return (current_value || 0) + 1;
      //     });
      //     this.gGALog(this.profile.url, 'AutoPilot',this.profile.autopilotURL )
      //     window.location.replace(this.profile.autopilotURL)
      //   }
      // }
      // else{
      //   this.autopilotValid = false
      // }

      


      // db.ref('/users/').orderByChild('url').equalTo(this.$route.params.uid.toLowerCase()).limitToFirst(1).once('value').then(function(snapshot) {
      //   let profileResults = snapshot.val()
      //   if(snapshot.val() === null){
      //     self.gGALog(self.$route.params.uid.toLowerCase(), "Page Not Found",)
      //     self.$router.replace({name:'Home'})
      //   }
      //   const uUID = Object.keys(profileResults)[0]
      //   self.userUID = uUID
      //   const profileResultsArray = Object.values(profileResults);
      //   self.profile = profileResultsArray[0];

      //     // try{
      //     //   if(typeof self.profile.googleAnalytics !== "undefined"){
      //     //     self.gaCode = self.profile.googleAnalytics
      //     //   }
      //     // }catch(e){
      //     //   console.log('custom GA error', e)
      //     // }

      //     // if(self.profile.ice && self.profile.iceLocation != undefined){
      //     //   db.ref("/users/" + this.userUID  +"/iceLocation/").remove();
      //     // }

      //     // // self.userDetails = self.profileif(!self.profile.mailjetID && self.profile.email){
      //     //   db.ref('users/'+ uUID +'/getmailjetid').transaction(function (current_value) {
      //     //     return self.profile.email;
      //     //   });
      //     // }

      // });
    },
    
    // created: function () {
      // let self = this
      // self.documentReferrer =document.referrer
      // console.log(document.referrer)
      // if(document.referrer.indexOf("instagram") == -1){
      //   self.documentReferrer = "NOT IG"
      // }
      // else{
      //   self.documentReferrer = "IG"
      // }
    // },
    mounted: function(){
      // console.log(this.userDetails.albumPlayer)
      // if(this.userDetails.albumPlayer){
      //   this.audioPlayer.addEventListener('loadeddata', this.playerLoaded);
      //   this.audioPlayer.addEventListener('timeupdate', this.playerUpdate);
      // }
      
      // let self = this
      // console.log('mounted', self.profile)
    },
    beforeDestroy() {
      if(this.userDetails.albumPlayer){
      this.audioPlayer.removeEventListener('loadeddata', this.onLoadedData);
      this.audioPlayer.removeEventListener('timeupdate', this.onTimeUpdate);
      }
      
      // ... other cleanup ...
    },
    watch:{
      albumPlayer(data){
        // let x = document.getElementById("albumPlayer"); 
        // if(this.$refs.albumPlayer.readyState >= 2){
        //   console.log('ready to play')
        // }
        // console.log('watching data', parseInt(x.duration))
      },
      'userDetails.version': {
        immediate: true,
        handler(newVal) {
          if (newVal === 3) {
            // Dynamically import the hero component
            import('./sections/hero.vue').then(module => {
              this.AsyncHero = module.default;
            });
          }
        }
      },
      'userDetails.sections': {
        immediate: true,
        handler(newSections) {
          if (newSections) {
            // Pre-load all section components
            newSections.forEach(section => {
              this.getSectionComponent(section.type);
            });
          }
        }
      }
    },
    computed:{
      albumPlayerProgress: function(){
        if (!this.audioPlayer || !this.audioPlayer.duration) return 0;
        return this.audioPlayer.played / this.audioPlayer.duration;
      },

      // Split slinks into smaller, focused computed properties
      filteredLinks: function() {
        if (!this.userDetails || !this.profile.links) return [];
        return Object.entries(this.profile.links).map(([id, link]) => ({
          ...link,
          id
        }));
      },

      validLinks: function() {
        return this.filteredLinks.filter(link => {
          if (_.size(link) === 1) {
            this.removeInvalidLink(link.id);
            return false;
          }
          return this.isLinkValid(link);
        });
      },

      orderedLinks: function() {
        return _.orderBy(this.validLinks, ["forcedOrder", "order"]);
      },

      slinks: function() {
        return this.orderedLinks.filter(link => !link.disabled);
      },

      getDiagnostics: function(){
        let self =this
        this.diagnostics.push('Docment Referrer: ' + document.referrer)
        this.diagnostics.push('Browser CodeName: ' + navigator.appCodeName)
        this.diagnostics.push('Browser Name: ' + navigator.appName)
        this.diagnostics.push('Browser Version: ' + navigator.appVersion)
        this.diagnostics.push('Platform: ' + navigator.platform)
        this.diagnostics.push('User-agent header: ' + navigator.userAgent)
        remoteConfig.fetchAndActivate().then(() => {
          self.diagnostics.push('Country: ' +  remoteConfig.getValue('country')._value)
        })
        
        
// txt += "<p>Cookies Enabled: " + navigator.cookieEnabled + "</p>";
// txt += "<p>Browser Language: " + navigator.language + "</p>";
// txt += "<p>Browser Online: " + navigator.onLine + "</p>";
// txt += "<p>User-agent header: " + navigator.userAgent + "</p>";
        // return navigator.userAgent
        return this.diagnostics
      },
      
      // getAdWidth(){
      //   this.$nextTick(() => {
      //   // console.log(document.getElementById('googleAd').offsetWidth)
      //   document.getElementById('googleAd').style.width = document.getElementById('googleAdContainer').offsetWidth
      //   return document.getElementById('googleAdContainer').offsetWidth
      //   })
      //   // return '350px'
      // },
      // referrerIG(){
      //   console.log('referrerIG')
      //   if(document.referrer == 'https://l.instagram.com/'){
      //     return true
      //   }
      //   else{
      //     return false
      //   }
      // },
      // getSona:function(){
      //   // console.log('Window', this.window)
     
          
      //       if(window.sona != undefined){
      //   console.log('getSona', window.sona.clientId)
      //   this.sonaClientId = window.sona.clientId
      //   return window.sona.clientId

      //   }
      //   else{
      //     // setTimeout(this.getSona, 500)
      //     return null
      //   }
       
        
      // },
      // getSonaClientId:function(){
      //   if(window.sona != undefined){
      //     return window.sona.clientId
      //   }
      //   else{
      //     return null
      //   }
      // },  
      isIOS: function(){
        return !!navigator.platform.match(/iPhone|iPod|iPad/)
      },
      // platform: function(){
      //   return navigator.platform
      // },
      
      userInfo: function(){
        const hasTemplate = this.template ? true : false
        let ad = null
        if(this.randomAd && this.randomAd.title != undefined){
          ad = this.randomAd.title
        }
        let user = {
          // 'key': this.profile['.key'],
          'key': this.userUID,
          'account': parseInt(this.userDetails.account),
          'enableUpgrades': this.userDetails.enableUpgrades,
          'warning': this.userDetails.warning,
          'url': this.userDetails.url,
          'iconStyle': this.userDetails.iconStyle,
          'email': this.userDetails.email ,
          'beta': this.userDetails.beta,
          'ad': ad,
          'linkStyling': this.userDetails.linkStyling !== undefined ? this.userDetails.linkStyling : null
        }
        
        if (this.userDetails.connectID){
          user.connectID = this.userDetails.connectID
        }
        if (this.userDetails.fbPixel){
          user.fbPixel = this.userDetails.fbPixel
        }
        if(this.userDetails.ticketNumber){
          user.ticketNumber = this.userDetails.ticketNumber
        }
        return user
      },
      
      countSuggestedPages: function(){
        return _.size(this.suggestedPages)
      },
      
      // getSuggestedPages: function(){
      //   let self = this
      //   db.ref('/users/').orderByChild('similarPages/'+this.userUID).equalTo(true).once('value').then(function(snapshot) {
      //     self.suggestedPages = _.orderBy(snapshot.val(), [(obj) => obj.promotedSP === undefined ? false : obj.promotedSP, (obj) => obj.account === undefined ? 7 : obj.account, 'pageViews'], ['desc', 'desc', 'desc'])
      //     self.suggestedPages =  self.suggestedPages.filter(obj => obj.similarPages.hasOwnProperty(self.userUID));
      //     self.suggestedPages =  self.suggestedPages.filter(obj => obj.url != self.userDetails.url);
      //     self.suggestedPages =  self.suggestedPages.filter(obj => (obj.dontSuggest === undefined ? false : obj.dontSuggest) !== true );
      //     if(self.userDetails.adult != true){
      //       self.suggestedPages =  self.suggestedPages.filter(obj => !obj.adult == true);
      //     }
      //   })
      // },
      // getSuggestedPages: function(){
      //   let self = this
      //   let prioritySuggestPages = null
      //   remoteConfig.ensureInitialized().then(() => {
      //     try{
      //       remoteConfig.fetchAndActivate().then(() => {
      //         let c = remoteConfig.getValue('suggestedPages');
      //         if(c){
      //           self.prioritySP = JSON.parse(c._value)
      //           for (var suggestion in self.prioritySP) {
      //             if(self.userDetails.adult && self.prioritySP[suggestion].active == true){
      //               self.suggestedPages.push(self.prioritySP[suggestion])
      //             }
      //             else if(self.prioritySP[suggestion].adult == false && self.prioritySP[suggestion].active == true){
      //               self.suggestedPages.push(self.prioritySP[suggestion])
      //             }
      //           }
      //         }
      //         let r = null
      //         var d = new Date();
      //         let period = 'p'+ d.getFullYear().toString().substr(-2) + ("0" + (d.getMonth() + 1)).slice(-2)
      //         r = db.ref('suggestions/'+ period + '/' +this.userUID)
      //         r.limitToLast(10).orderByValue().once("value", function(snapshot) {
      //           let csp = _.size(snapshot.val())
      //           if(csp == 0){
      //             self.suggestedPages = JSON.parse(remoteConfig.getValue('spFiller')._value);
      //           }
      //           let x = 0
      //           let sp = []
      //           snapshot.forEach(function(data) {
      //             let retrievedHistory = JSON.parse(localStorage.getItem("h"));
      //             db.ref('users/' + data.key).once("value", function(snapshot) {
      //               let pushSuggestion = (snapshot.val().adult == true && self.userDetails.adult != true) ? false : true;
      //               if(pushSuggestion){
      //                 let account = 0
      //                 if(snapshot.val().account == 7 || snapshot.val().parent || snapshot.val().promotedSP){
      //                   account = 7
      //                 }
      //                 let promotedSP = false
      //                 if(snapshot.val().promotedSP != undefined){
      //                   promotedSP = snapshot.val().promotedSP
      //                 }
      //                 let picture = snapshot.val().picture
      //                 if(picture == ''){
      //                   picture = "https://cdn.myslink.app/assets%2Fslink_placeholder.png?alt=media&token=10b33e0a-10b6-40c0-b0ba-004272c70945"
      //                 }
      //                 let name = snapshot.val().name
      //                 if(name == ''){
      //                   name = snapshot.val().url
      //                 }
      //                 self.suggestedPages.push(
      //                 {
      //                   uid: data.key, 
      //                   views: parseInt(data.val()), 
      //                   icon: picture, 
      //                   name: name, 
      //                   url:snapshot.val().url,
      //                   account: account,
      //                   promotedSP: promotedSP
      //                 })
      //                 self.suggestedPages = _.orderBy(self.suggestedPages, ['promotedSP','account', 'views'], ['desc','desc', 'desc'])
      //               } 
      //               x = x+1

      //               if(_.size(self.suggestedPages) < 9 &&  (csp === x)){
      //                 let required = (Math.ceil(_.size(self.suggestedPages) / 3)*3)- _.size(self.suggestedPages)
      //                 let f = JSON.parse(remoteConfig.getValue('spFiller')._value);
      //                 for(var i = 0; i < required; i++){
      //                   self.suggestedPages.push(f[i])
      //                   self.suggestedPages = _.orderBy(self.suggestedPages, ['promotedSP','account', 'views'], ['desc','desc', 'desc'])
      //                 }
      //               }
      //             })
      //           });
      //         })
      //       })
      //     }catch(e){
      //       console.log('rcerr', e)
      //     }
      //   })
      //   .catch((err) => {
      //     console.error('Firebase Remote Config failed to initialize', err);
      //   });
      // },
      // setPageWidth: function(){
      //   return this.userDetails.fullScreen ? '100%' : 'calc(100% - 40px)';
      // },
      // getWhiteFrame:function(){
      //   return ((this.userDetails.floating && (this.userDetails.account == 7 || this.userDetails.enableUpgrades)) || this.userDetails.flat) ? 0 : 20;
      // },
      // getFloatingOverflow:function(){
      //   return this.userDetails.floating && (this.userDetails.account == 7 || this.userDetails.enableUpgrades) ? 'unset' : 'hidden';
      // },
      // getLinkSize:function(){
      //   return this.userDetails.compactLinks ? '56px' : '72px';
      // },
      // getPageTitle: function(){
      //   try{
      //     if (this.profile.customPageTitle != undefined){
      //       return this.profile.customPageTitle
      //     }
      //     else{
      //       return this.profile.name + "'s Digital Business Card"
      //     }
          
      //   }
      //   catch(e){
      //   }
      // },
      textAlign: function(){
        return this.userDetails.showIcons ? 'text-align: center' : 'text-align: left';
      },
      templateLinks: function() { //updated 2021-05-05
        try {
          if (this.template) {
            this.template.above = _.chain(this.template.above).filter(s => !s.disabled).orderBy("order").value();
            this.template.below = _.chain(this.template.below).filter(s => !s.disabled).orderBy("order").value();
            return this.template;
          }
        } catch (e) {
          console.log("error getting template");
        }
      },
    },
    methods: {
      removeInvalidLink(id) {
        db.ref(`users/${this.userUID}/links/${id}`).transaction(() => null);
      },

      isLinkValid(link) {
        if (!link.site) {
          console.log('invalid link entry');
          this.removeInvalidLink(link.id);
          return false;
        }

        if ((link.hideIG && document.referrer.includes("instagram")) || 
            (link.hideTikTok && navigator.userAgent.includes("Bytedance"))) {
          return false;
        }

        if (link.premium && !this.isAllowed(7)) return false;
        if (this.visitorAge === false && link.adult) return false;
        if (this.withCard === false && link.cardShow) return false;
        if (this.withCard === true && link.cardHide) return false;

        return this.checkDomainRestrictions(link);
      },

      checkDomainRestrictions(link) {
        if (!link.onlyShowDomain) return true;
        
        const referrer = document.referrer.toLowerCase();
        const domains = Array.isArray(link.onlyShowDomain)
          ? link.onlyShowDomain.map(d => d.toLowerCase())
          : [link.onlyShowDomain.toLowerCase()];
        
        return referrer === '' && domains.includes('*') || 
               domains.some(domain => referrer.includes(domain));
      },
      sectionLinks(section) {
        console.log('getting links for section', section)
        if(this.userDetails != null){
          let tempSlinks = this.profile.links
          for (let x in tempSlinks){
            let link = tempSlinks[x]
            link.id = x
            if (_.size(link) === 1) {
              db.ref(`users/${this.userUID}/links/${x}`).transaction(() => null);
            }
            if (link.site === undefined) {
              console.log('invalid link entry');
              link.disabled = true;
              db.ref(`users/${this.userUID}/links/${x}`).remove();
              continue;  // Skip further processing for this link
            }
            if ((link.hideIG && document.referrer.indexOf("instagram") != -1) || 
                (link.hideTikTok && navigator.userAgent.includes("Bytedance"))) {
              link.disabled = true;
              continue;
            }
            if (!link.aspectRatio && this.getSlinkCanInLine(link.site)) {
              link.aspectRatio = this.arDimensions[link.site];
            }
            if (['YouTube Player', 'Spotify Player', 'Text Block'].includes(link.site) &&
                (this.userDetails.account !== 7 || !this.userDetails.enableUpgrades)) {
              link.premium = true;
            }
            if (link.premium && !this.isAllowed(7)) {
              link.disabled = true;
              continue;
            }
            link.base = link.base || "";
            link.suffix = link.suffix || "";
            if (link.site === "Image" && link.safeSearchResults === undefined) {
              link.safeSearchResults = [];
              link.safeSearchResults.approved = true;
            }
            if ((this.isDev || this.isLocal) && link.devOnly) {
              link.disabled = false;
            }
            if (this.visitorAge == false && link.adult) {
              console.log('####', link.site)
              link.disabled = true;
              continue;
            }
            if (!link.disabled) {
              link.disabled = (this.withCard === false && link.cardShow === true) || 
                              (this.withCard === true && link.cardHide === true);
            }
            
            if (link.onlyShowDomain) {
              console.log('onlyShowDomain history', window.history, window.opener)
              // alert('onlyShowDomain ' + document.referrer + ' ' +window.opener)

              const referrer = document.referrer.toLowerCase();
              
              // Convert to array if it's not already (for backwards compatibility)
              const domains = Array.isArray(link.onlyShowDomain)
                ? link.onlyShowDomain.map(d => d.toLowerCase())
                : [link.onlyShowDomain.toLowerCase()];
              console.log('domains', domains) 
              // Check if referrer is empty and '*' is in domains
              if (referrer === '' && domains.includes('*')) {
                link.disabled = false;
              }
              // Check if referrer includes any of the allowed domains
              else if (!domains.some(domain => referrer.includes(domain))) {
                link.disabled = true;
              }
            }
          }

          return _.orderBy(tempSlinks, ["forcedOrder", "order"]).filter(link => !link.disabled);
        }
      },
      importHostedFont(font){
        
      },

      playerSongEnded(){
        console.log("Playback finished.", this.albumPlayer.index);
        // this.albumPlayer.index = this.albumPlayer.index + 1
        this.albumPlayer = this.profile.links[this.albumPlayer.linkId].album[this.albumPlayer.index + 1]
        this.audioPlayer.src= this.albumPlayer.source
        this.audioPlayer.play()
      },
      convertTimeHHMMSS(val) {
        let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);

        return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
      },
      playerUpdate(e){
        // console.log('player update', e)
        // let x = document.getElementById("albumPlayer"); 
        this.player.current = this.audioPlayer.currentTime
        this.playerProgress = (this.audioPlayer.currentTime / this.audioPlayer.duration)* 100
      },
      playerLoaded(){
        // let x = document.getElementById("albumPlayer"); 
        // console.log('player loaded', this.audioPlayer.duration)
        this.player.duration = this.audioPlayer.duration
        // x.play();
        this.audioPlayer.play()

      },
      playAudio(){
        // let x = document.getElementById("albumPlayer"); 
        // x.play();
        console.log(this.audioPlayer)
        this.audioPlayer.play();
      },
      handleLinkEvent(eventData) {
        console.log('handleLinkEvent', eventData)
        if(eventData.task == 'albumPlayer'){
          
          this.albumPlayer = eventData.data

          // let x = document.getElementById("albumPlayer"); 
          this.audioPlayer.src = eventData.data.source
          // x.src = eventData.data.source
          this.albumPlayerProgress
          // if( document.getElementById("albumPlayer").src){
            // x.play();
            // console.log(x)
          // }


        }
      console.log('Received data from child:', eventData);
      // Handle the data as needed
    },
      processCard(){
        if(this.$route.params.card === true || this.$route.query.c){
          this.gGALog(this.$route.params.uid.toLowerCase(), "PageView", "Card")
          this.withCard = true
          history.pushState({}, '', '../'+ this.$route.params.uid)
        }
      },
      setPageTitle(title){
        const pageTitle = this.profile.customPageTitle || `${this.profile.name}'s Digital Business Card powered by Slink`;
        document.title = pageTitle
      },
      loadCustomFont() {
        if (this.userDetails.customFont) {
          this.customFont = `https://fonts.googleapis.com/css2?family=${this.userDetails.customFont.replace(/ /g, '+')}&display=swap`;
          this.metaLinks.push({ rel: 'stylesheet', href: this.customFont });
          this.updateDocumentHead();
        }
      },
      // loadHostedFont() {
      //   if (this.userDetails.customHostedFont) {
      //     let hostedFont = `https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F-NtunfJ7_h7neo8YIHLJ%2FSimpsonfont%20DEMO.otf?alt=media&token=50ff93e1-5151-4c29-8690-d9d671d08248?family=hostedFont&display=swap`;
      //     this.metaLinks.push({ rel: 'stylesheet', href: hostedFont });
      //     this.updateDocumentHead();
      //   }
      // },
      loadHostedFont() {
  if(this.userDetails.customHostedFont) {
    const fontFaceStyle = `@font-face {
      font-family: 'hostedFont';
      src: url('${this.userDetails.customHostedFont}') format('woff2');
      font-weight: normal;
      font-style: normal;
    }`;
    
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.textContent = fontFaceStyle;
    document.head.appendChild(styleSheet);
  }
},


      updateDocumentHead() {
        this.$meta().refresh();
      },
      // async getAdvert() {
      //   try {
      //     if (!(this.userDetails.ad || this.userDetails.parent || this.userDetails.children || this.userDetails.enterprise || this.userDetails.account === 7 || this.userDetails.account === 6)) {
      //       const adsSnapshot = await db.ref('ads/').orderByChild('active').equalTo(true).once('value');
      //       const adsData = adsSnapshot.val();
      //       await remoteConfig.fetchAndActivate();
      //       let concatAds = Object.values(adsData).map((ad, key) => ({ ...ad, '.key': key }));
      //       let cummulativeWeight = 0;

      //       concatAds.forEach(ad => {
      //         ad.adult = typeof ad.adult !== 'undefined' ? ad.adult : false;
      //         ad.banner = typeof ad.banner !== 'undefined' ? ad.banner : true;
      //         ad.hideFromAdult = typeof ad.hideFromAdult !== 'undefined' ? ad.hideFromAdult : false;
      //         ad.weight = typeof ad.weight !== 'undefined' && ad.weight !== 0 ? ad.weight : 1;
      //         if (ad.category !== undefined && this.userDetails.categories && Object.values(this.userDetails.categories).includes(ad.category)) {
      //           ad.weight *= 50;
      //         }
      //         let isTargetCountry = ad.targetCountry === 'All' || ad.targetCountry === remoteConfig.getValue('country')._value;
      //         let isSuitableForAdult = !(ad.adult && !this.userDetails.adult);
      //         let isHiddenFromAdult = !(ad.hideFromAdult && this.userDetails.adult);
      //         if (isTargetCountry && isSuitableForAdult && isHiddenFromAdult) {
      //           cummulativeWeight += ad.weight;
      //           ad.cummulativeWeight = cummulativeWeight;
      //         }
      //       });
      //       let filteredAds = concatAds.filter(ad => ad.cummulativeWeight);
      //       let randomAdIndex = Math.floor(Math.random() * cummulativeWeight);
      //       this.randomAd = filteredAds.find(ad => ad.cummulativeWeight >= randomAdIndex);

      //       if(this.randomAd.adScript != undefined){
      //         let scriptEle = document.createElement("script");
      //         scriptEle.setAttribute("src", this.randomAd.adScript);
      //         scriptEle.setAttribute("type", "text/javascript");
      //         scriptEle.setAttribute("async", true);
      //         document.getElementsByTagName('head')[0].appendChild(scriptEle);
      //         // success event 
      //         scriptEle.onload = function() {
      //           // alert("Script loaded and ready");
      //           console.log('script loaded and readdy')
      //           self.adCode = self.randomAd.adCode != undefined ? self.randomAd.adCode : null
      //         };
      //         scriptEle.onerror = function(){
      //           console.log('there was an error')
      //         }
      //         scriptEle.addEventListener("error", (ev) => {
      //           console.log("Error on loading file", ev);
      //         });
      //       }
      //       const event = this.randomAd.adult ? "Sponsored Displayed Adult" : "Sponsored Displayed"
      //       this.gGALog(this.$route.params.uid.toLowerCase(), event, this.randomAd.title)
      //     }
      //   } catch (error) {
      //     console.error('Error fetching adverts:', error);
      //   }
      // },
      async getAdvert() {
        try {
          // console.log('getting adverts')
            if (!(this.userDetails.ad || this.userDetails.parent || this.userDetails.children || this.userDetails.enterprise || Number(this.userDetails.account) === 7 || this.userDetails.account === 6)) {
                const adsSnapshot = await db.ref('ads/').orderByChild('active').equalTo(true).once('value');
                const adsData = adsSnapshot.val();
                await remoteConfig.fetchAndActivate();
                let concatAds = [];
                adsSnapshot.forEach((adSnapshot) => {
                    let ad = adSnapshot.val();
                    ad['.key'] = adSnapshot.key; // Use the original database key
                    concatAds.push(ad);
                });

                let cummulativeWeight = 0;
                concatAds.forEach(ad => {
                    ad.adult = typeof ad.adult !== 'undefined' ? ad.adult : false;
                    ad.banner = typeof ad.banner !== 'undefined' ? ad.banner : true;
                    ad.hideFromAdult = typeof ad.hideFromAdult !== 'undefined' ? ad.hideFromAdult : false;
                    ad.weight = typeof ad.weight !== 'undefined' && ad.weight !== 0 ? ad.weight : 1;
                    if (ad.category !== undefined && this.userDetails.categories && Object.values(this.userDetails.categories).includes(ad.category)) {
                        ad.weight *= 50;
                    }
                    let isTargetCountry = ad.targetCountry === 'All' || ad.targetCountry === remoteConfig.getValue('country')._value;
                    let isSuitableForAdult = !(ad.adult && !this.userDetails.adult);
                    let isHiddenFromAdult = !(ad.hideFromAdult && this.userDetails.adult);
                    if (isTargetCountry && isSuitableForAdult && isHiddenFromAdult) {
                        cummulativeWeight += ad.weight;
                        ad.cummulativeWeight = cummulativeWeight;
                    }
                });

                let filteredAds = concatAds.filter(ad => ad.cummulativeWeight);
                let randomAdIndex = Math.floor(Math.random() * cummulativeWeight);
                this.randomAd = filteredAds.find(ad => ad.cummulativeWeight >= randomAdIndex);

                if(this.randomAd && this.randomAd.adScript != undefined){
                    let scriptEle = document.createElement("script");
                    scriptEle.setAttribute("src", this.randomAd.adScript);
                    scriptEle.setAttribute("type", "text/javascript");
                    scriptEle.setAttribute("async", true);
                    document.getElementsByTagName('head')[0].appendChild(scriptEle);

                    scriptEle.onload = function() {
                        console.log('script loaded and ready');
                    };
                    scriptEle.onerror = function(){
                        console.log('there was an error');
                    }
                    scriptEle.addEventListener("error", (ev) => {
                        console.log("Error on loading file", ev);
                    });
                }

                const event = this.randomAd && this.randomAd.adult ? "Sponsored Displayed Adult" : "Sponsored Displayed";
                this.gGALog(this.$route.params.uid.toLowerCase(), event, this.randomAd ? this.randomAd.title : '');
                return this.randomAd; // Return the whole random ad object
            }
        } catch (error) {
            console.error('Error fetching adverts:', error);
        }
        return null; // Return null if no ad is selected or in case of error
      }, 
      async fetchUserProfile() {
        try {
          console.log('fetchUserProfile', this.$route.params.uid.toLowerCase())
          let snapshot = await db.ref('/users/').orderByChild('url').equalTo(this.$route.params.uid.toLowerCase()).limitToFirst(1).once('value');
          let profileResults = snapshot.val();
          if (profileResults === null) {
            this.gGALog(this.$route.params.uid.toLowerCase(), "Page Not Found");
            this.$router.replace({ name: 'Home' });
            return;
          }
          this.userUID = Object.keys(profileResults)[0];;
          const profileResultsArray = Object.values(profileResults);
          this.profile = profileResultsArray[0];

          if (this.profile.emailVerifiedRequired === true || this.profile.warning === true) {
            this.$router.replace({ name: 'Page Not Found' });
          }
          this.processCard();

          // if(this.$route.params.card === true || this.$route.query.c){
          //   this.gGALog(this.$route.params.uid.toLowerCase(), "PageView", "Card")
          //   this.withCard = true
          //   history.pushState({}, '', '../'+ this.$route.params.uid)
          // }

          const defaults = {
            'account': this.profile.parent != undefined ? 7 : 0,
            'bio': this.profile.bio == undefined || this.profile.bio === '<blank>' ? null : this.profile.bio,
            'adult': false,
            'enableUpgrades': false,
            'altProfile': 0,
            'iconStyle': 0,
            'pictureShape': 'squircle',
            'adult': false,
            'fullColourButtons': false,
            'background': '#ffffff',
            'background2': '#ffffff',
            'backgroundImage': null,
            'picture': null,
            'backgroundFilter': 'none',
            'headerColor': '#ffffff',
            'ad': false,
            'socialShareColour': '#ffffff',
            'socialShareTextForce': false,
            'socialShareTextColour': '#000000',
            'sensitiveContent': false,
          }
          this.profile = { ...defaults, ...this.profile };
          // for (var property in defaults) {
          //   if (this.profile[property] === undefined) {
          //     this.profile[property] = defaults[property]
          //   }
          // }
          if(this.profile.parent != undefined){
            this.profile.account = 7
          }
          if(this.profile.showIcons == true){
            this.profile.iconStyle = 3
          }
          if(this.profile.template && this.profile.parent){
            var templateUID = this.profile.parent ? this.profile.parent : this.profile[0]['.key'];
            const templateData = await db.ref('templates/'+ templateUID).once('value')//.then(function(snapshot)
              this.template = templateData.val()
              console.log(this.template)
              if(this.template && this.template.settings != undefined){
                for(var i in this.template.settings){
                  this.profile[i] = this.template.settings[i]
                  if(i == 'linkBorderColour'){
                    document.body.style.setProperty('--linkBorder',this.template.settings[i])
                  }
                }
              }
          }
          // console.log('getBackground')
          // if(this.profile.videoBackground){
          //   console.log('has video background')
          //   document.body.style.setProperty('--background',this.getBackground)
          // }

          if(this.profile.linkBorder){
            document.body.style.setProperty('--linkBorder',this.profile.linkBorderColour)
          }
          if(this.profile.autoBackground){
            this.profile.background += '55'
            this.profile.background2 += '55'
            document.body.style.setProperty('--background', 'none')
            document.body.style.setProperty('--autoBackground', 'linear-gradient('+ this.profile.background + ', '+ this.profile.background2 +'), url("'+ this.profile.picture +'")')
          }
          else if(this.profile.videoBackground){
            document.body.style.setProperty('--background', 'none')
            document.body.style.setProperty('--autoBackground', 'linear-gradient('+ this.profile.background + ', '+ this.profile.background2 +'), url("'+ this.profile.picture +'")')
          }
          else{
            document.body.style.setProperty('--background', 'linear-gradient('+ this.profile.background + ', '+ this.profile.background2 || this.profile.background +')')
          }
          if(this.profile.backgroundImage){
            console.log('slinkview backgroundImage', this.profile.backgroundImage)
            document.body.style.setProperty('--background', 'none')

            document.body.style.setProperty('--background', `url(${this.profile.backgroundImage})`)
          }

          if(this.profile.v3){
            document.body.style.setProperty('--backgroundv3', this.profile.background)
            document.body.style.setProperty('--background', this.profile.background)
            document.body.style.setProperty('--backgroundv3-alt', `color-mix(in srgb, ${this.profile.background} 80%, black)`);
          }

          if(this.profile.albumPlayer){
            this.audioPlayer = new Audio(),
            this.audioPlayer.addEventListener('loadeddata', this.playerLoaded);
            this.audioPlayer.addEventListener('timeupdate', this.playerUpdate);
            this.audioPlayer.addEventListener('ended', this.playerSongEnded);
          }
          this.userDetails = this.profile
          // Additional operations based on the fetched profile...
          // (e.g., handle hop links, check mailjet status, etc.)
        } catch (error) {
          console.error('Error fetching user profile:', error);
          // Handle the error appropriately
        }
      },
      async handleHopLinks() {
  try {
    if (this.$route.params.hop && this.profile && this.profile.links) {
      for (const linkKey in this.profile.links) {
        const hopLink = this.profile.links[linkKey];
        const isHopLinkMatch = hopLink.hopLink && this.$route.params.hop.toLowerCase() === hopLink.hopLink.toLowerCase();

        if (isHopLinkMatch) {
          this.hop = true
          this.gaLoggedSlinkClink(this.profile.url, linkKey, hopLink.site);
          let isMobile = document.referrer.indexOf("instagram") !== -1 || document.referrer.indexOf("tiktok") !== -1;
          if (hopLink.site === 'YouTube Latest' && isMobile) {
            let toLink = `${hopLink.base}${hopLink.user}${hopLink.suffix}?mobile=true`;
            window.location.replace(toLink);
          } else if (hopLink.site === 'Image') { // New condition for 'Image'
            window.location.replace(hopLink.imageLink); // Pass hopLink.user directly
          } else {
            window.location.replace(`${hopLink.base}${hopLink.user}${hopLink.suffix}`);
          }
          break; // Exit the loop after handling the hop link
        }
      }
    }
  } catch (error) {
    console.error('Error handling hop links:', error);
    // Handle the error appropriately
  }
},
      // async updateVisit(pageId, uid) {
      //   let currentTimestamp = Date.now();
      //   let retrievedHistory = JSON.parse(localStorage.getItem("historyv3")) || {};
      //   retrievedHistory[pageId] = currentTimestamp;
      //   localStorage.setItem("historyv3", JSON.stringify(retrievedHistory));
      //   localStorage.removeItem('history');
      //   localStorage.removeItem('h');
      //   localStorage.removeItem('historyv2');
      //   for (let historyPageId in retrievedHistory) {
      //     let visitTimestamp = retrievedHistory[historyPageId];
      //     if(this.userUID != historyPageId){
      //       await db.ref('userVisits/' + pageId + '/' + historyPageId).transaction((currentVisit) => {
      //         if (  !currentVisit) {
      //           return { id: historyPageId, timestamp: visitTimestamp };
      //         }
      //       });
      //     }
      //   }
      // },
      // async getSuggestionnv2(pageId) {
      //   const snapshot = await db.ref('/userVisits/' + pageId).orderByChild('timestamp').limitToFirst(20).once('value');
      //   const recentVisitsData = snapshot.val();
      //   console.log(pageId)
      //   console.log('recentVisitsData',recentVisitsData)

      //   // let retrievedHistory = JSON.parse(localStorage.getItem("historyv3")) || {};
      //   let visitedPages=  new Set(Object.keys(JSON.parse(localStorage.getItem("historyv3")) || {})); // Convert to a Set for efficient lookup
      //   let filteredVisits = [];
      //   if (recentVisitsData && typeof recentVisitsData === 'object') {
      //     for (let visitPageId in recentVisitsData) {
      //       if (recentVisitsData.hasOwnProperty(visitPageId) && !visitedPages.has(visitPageId)) {
      //         filteredVisits.push(visitPageId);
      //       }
      //     }
      //   }
      //   console.log('filteredVisits', filteredVisits)
      // },
      async getTemplate(){
        const templateUID = this.profile.parent ? this.profile.parent : this.profile[0]['.key'];
        const templateRef = db.ref('templates/'+ templateUID)
        const templateSnapshot = await templateRef.once('value')
        const templateValues = templateSnapshot.val()

        if(templateValues['settings'] != undefined){
          for(var i in templateValues.settings){
            self.profile[i] = templateValues.settings[i]
            // console.log('template settings:', i,templateValues.settings[i],self.profile[i] )
            if(i == 'linkBorderColour'){
              document.body.style.setProperty('--linkBorder',templateValues.settings[i])
            }
          }
        }
      },
      getDropBackground(fullColour, bg){
        return fullColour ? bg : "#ffffff"
      },
      getTextColour(link) { //updated 2021-05-05
        if (link.ForceTextColour) {
          return link.color;
        }
        if (link.background === 'white') {
          link.background = '#ffffff';
        } else if ((this.userDetails.fullColourButtons || false) && (this.userDetails.account === 7 || this.userDetails.enableUpgrades)) {
          const r = parseInt(link.background.substr(1, 2), 16);
          const g = parseInt(link.background.substr(3, 2), 16);
          const b = parseInt(link.background.substr(5, 2), 16);
          const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
          return (yiq >= 128) ? '#000000' : '#ffffff';
        } else {
          return '#000000';
        }
      },
      // correctTreasureHunt(id, question, status){
      //   let th = {'treasureHuntID': id, question: question, status:status}
      //     localStorage.setItem("treasureHunt", JSON.stringify(th));

      // },
      mjAdult(mjid) {
        fetch('../api/mjAdult?mjid='+ mjid, {
            credentials: "same-origin",
            mode: "no-cors",
            method: 'POST'
          }).then(res => { console.log(res)})
      },
      createNewUser(user) {
      // console.log('new user', user)
      var username = user.email.split("@",1)[0].replace(/[\W\\_]/g,'').toLowerCase()
      var url = user.email.split("@",1)[0].replace(/[\W\\_]/g,'').toLowerCase()
      if (user.displayName != null){
        username = user.displayName
      }
      var picture = ""
      if(user.photoURL != null){
        picture = user.photoURL
      }

      try {
        let referrer =  this.userUID
        let newUser = db.ref('users/' + user.uid + '/').update({
          name: username,
          ad:false,
          picture: picture,
          url: url,  
          account:0 , 
          onboarding: true,
          email: user.email,
          bio:'Welcome to my Slink Page',
          ad:false,
          socialShare:false,
          referrer: referrer,
          pictureShape:'squircle'
        })
        if(!fb.auth().currentUser.emailVerified){
          fb.auth().currentUser.sendEmailVerification()
        }
        this.$router.replace({name:'Admin'})

      }
      catch (e) {console.log(e)}
      db.ref("url/"+ user.uid).update({url: url})
      if(this.$route.query.utm_source){
        this.gGALog(user.uid, "SignUp Referral", this.userUID)
      }
    },
    loginByGoogle: function(){
      const provider = new Firebase.auth.GoogleAuthProvider()
      fb.auth().signInWithPopup(provider).then((result) => {
        let self = this;
        // console.log('login with google', result.user.uid)
        db.ref("users/"+result.user.uid+"/url").once('value').then(function(snapshot){
          if (snapshot.val() === null) {
            self.createNewUser(result.user)
            self.gGALog(result.user.uid, "SignUp", "SignUp Google")
          }
        })
        this.$router.replace({name:'Admin'});
        this.user = result.user
        this.gGALog(result.user.uid, "Login", "Login Google")
      }).catch(err => {
        this.showNotification(err.message);

        console.log(err)
      })

      // self.showNotification(error.message);
    },
    signupByEmail: function() {
      
      fb.auth().createUserWithEmailAndPassword(this.signupEmail.toLowerCase().trim(), this.signupPassword).then((success) => {
        this.createNewUser(success.user)
        // console.log(success.user.uid)
        this.gGALog(success.user.uid, "SignUp", "SignUp Email")
      }).catch((err) => {
        if(err.message.includes("Failed to execute")){
          
        }
        // console.log(err);
        // this.error = err;
        this.showNotification(err.message);
          this.gGALog(this.signupEmail, "Signup Failed", err.message)

      })
    },
//     getBrowser: function(){
//         this.diagnostics.push('Browser CodeName: ' + navigator.appCodeName)
//         this.diagnostics.push('Browser Name: ' + navigator.appName)
//         this.diagnostics.push('Browser Version: ' + navigator.appVersion)
//         this.diagnostics.push('Platform: ' + navigator.platform)
//         this.diagnostics.push('User-agent header: ' + navigator.userAgent)
//         this.diagnostics.push('Country: ' +  remoteConfig.getValue('country')._value)
// // txt += "<p>Cookies Enabled: " + navigator.cookieEnabled + "</p>";
// // txt += "<p>Browser Language: " + navigator.language + "</p>";
// // txt += "<p>Browser Online: " + navigator.onLine + "</p>";
// // txt += "<p>User-agent header: " + navigator.userAgent + "</p>";
//         return navigator.userAgent
//       },
      linkFormatting: function(site){
        let lf = {
          'media': this.getSlinkCanInLine(site),
          'showIcons': this.userDetails.showIcons,
          'compactLinks': this.userDetails.compactLinks,
          'fullColourButtons': this.userDetails.fullColourButtons,
          'backgroundImage': this.userDetails.backgroundImage,
          'flat': this.userDetails.flat,
          'clearLinks' : this.userDetails.clearLinks,
          'floating' : this.userDetails.floating,
          'flat': this.userDetails.flat, 
          'buttonGlass': this.userDetails.buttonGlass,

        }
        // console.log('linkFormatting', site, lf.media)
        return lf
      },
      isAllowed: function(requirement){
        return (this.userDetails.account == requirement || this.userDetails.enableUpgrades) ? true : false;
      },
      imageBackground:function(image){
        return ({'background-image':image})
      },
      // track () {
      //   page('/')
      // },
      // sections:function(alphaOrder) {
      //   var tempSections = this.slinks
      //   tempSections = tempSections.filter(s => {
      //     return (s.site == 'Section' || s.site == 'Link Group') && s.disabled == false;
      //   });
      //   if(alphaOrder){
      //     return _.orderBy(tempSections, "user");
      //   }
      //   else{
      //     return tempSections
      //   }
      // },
      sections(alphaOrder) {
        const filteredSections = this.slinks.filter(slink => 
          (slink.site === 'Section' || slink.site === 'Link Group') && !slink.disabled
        );
        return alphaOrder ? filteredSections.sort((a, b) => a.user.localeCompare(b.user)) : filteredSections;
      },
      setVistorAge: function(age){
        this.visitorAge = age
      },
      downloadvCard: function(){
         console.log('download vCard')
         const imageURL = this.userDetails.picture.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-vcf')
         fetch(imageURL)
        .then(response => response.blob())
        .then(blob => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result.split(',')[1]);
                };
                reader.readAsDataURL(blob);
            });
        })
        .then(imageBase64 => {
            let vcard = 'BEGIN:VCARD' + '\n';
            vcard += 'VERSION:3.0' + '\n';
            vcard += 'N;CHARSET=utf-8:;' + this.userDetails.name + ';;;;' + '\n'
            vcard += 'FN;CHARSET=utf-8:' + '\n'
            vcard += 'PHOTO;ENCODING=b;TYPE=image/png:' + imageBase64 + '\n';
            if (this.userDetails.altProfile == 20) {
                vcard += 'ORG:' + this.userDetails.business.company + '\n';
                vcard += 'TITLE:' + this.userDetails.business.title + '\n';
                vcard += 'EMAIL;TYPE=PREF,INTERNET:' + this.userDetails.business.email + '\n';
                vcard += 'TEL;TYPE=WORK,voice:' + this.userDetails.business.phone + '\n';
                vcard += 'URL:' + this.userDetails.business.linkHome + '\n';
            }
            vcard += 'item1.URL;type=pref:https://www.myslink.app/' + this.userDetails.url + '\n';
            vcard += 'item1.X-ABLabel:Slink Digital Business Card\n';
            vcard += 'END:VCARD';
            const blob = new Blob([vcard], { type: 'text/vcard' });
            const filename = this.userDetails.name + '.vcf';
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
        .catch(error => {
            console.error('Error fetching or encoding image:', error);
        });
      },
      linkScheduled: function(link){
        if(link.scheduled){
          var currentDate = new Date().getTime()
          if (link.start == undefined){
            link.start= ''
          }
          if (link.end == undefined){
            link.end= ''
          }
          var startDate = new Date(link.start.replace(/, /g, "-")).getTime()
          var endDate = new Date(link.end.replace(/, /g, "-")).getTime()
          var startValid = !link.start || startDate < currentDate
          var endValid =!link.end || endDate > currentDate
          return startValid && endValid ? true : false;
        }
        else{
          return true
        }
      },
      linkEnabled: function(link){
        return (link.disabled != true && this.linkScheduled(link)) ? true : false;
      },
      getGallery: function(images){
        let imgList = images.split(";")
        if(imgList.length > 9 ){
          imgList =imgList.split(9)
        }
        return imgList
      },
      embedLink: function(embedCode, site){
        console.log('fn(embedlink)', site)
        let res = embedCode.match(/http([^"])*/g)
        if(site == 'YouTube Player'){
          res[0] = res[0].replace(/(youtube.com\/watch\?v=|youtu.be\/)/i,'youtube.com/embed/')
          res[0] = res[0].replace(/youtube.com\/playlist\?list=/i,'youtube.com/embed/?listType=playlist&list=')
        }
        else if(site == 'Spotify Player'){
          res[0] = res[0].replace(/open.spotify.com\/artist/i,'open.spotify.com/embed/artist')
          res[0] = res[0].replace(/open.spotify.com\/track/i,'open.spotify.com/embed/track')
          res[0] = res[0].replace(/open.spotify.com\/album/i,'open.spotify.com/embed/album')
          res[0] = res[0].replace(/open.spotify.com\/playlist/i,'open.spotify.com/embed/playlist')
          res[0] = res[0].replace(/open.spotify.com\/show/i,'open.spotify.com/embed-podcast/show')
        }  
        else if(site == 'Apple Music Player'){
          res[0] = res[0].replace(/\/music.apple.com/i,'/embed.music.apple.com')
        } 
        // else if(site == 'Vimeo Player'){
        //   console.log('vimeo')
        //   res[0] = res[0].replace('https://vimeo.com','https://player.vimeo.com/video')
        //   console.log('vimeo player', res[0])
        // }  
        else if(site == 'Twitch Player'){
          if(res[0].includes('videos')){
            //var str = "Hello world, welcome to the universe.";
            //var n = str.includes("world");
            //https://www.twitch.tv/videos/695619630
            //https://player.twitch.tv/?parent=www.myslink.app&parent=myslink.app&video=695619630
            res[0] = res[0].replace(/\/www.twitch.tv\//i,'/player.twitch.tv/')
            res[0] = res[0].replace(/videos\//i,'?parent=www.myslink.app&parent=myslink.app&video=')
          }
          else{
            res[0] = res[0].replace(/\/www.twitch.tv\//i,'/player.twitch.tv/?parent=www.myslink.app&parent=myslink.app&channel=')
          }
        }   
        return res[0]
      },
      embedLinkHeight: function(id, embedCode){
        let height = '200px'
        try{
          if(site != 'YouTube Player'){
            let res = embedCode.match(/\bheight="([^"])*"/g)
            height = res[0].substring(8,res[0].length-1)+"px"
            height = height.replace('pxpx','px')
          }
        }
        catch (e){
        }        
        return height
      },
      setActiveVideoPlayer(video){
        this.activeVideo = video
      },
      openQRDialog(title, base, details, suffix){
        let link = base + details.trim() + suffix;
        this.qrcode.title = title
        this.qrcode.contentHtml = '<div style="width:100%; text-align:center;top: 1vh;position: sticky;"><img src="https://api.qrserver.com/v1/create-qr-code/?data='+ link +'" style="max-width:300px; width: 90%; padding: 10px; background: white; border-radius: 20px;"><p style="padding-top:20px"></div>'
        this.$refs['qrcodeDialog'].open();
      },
      openDialog(ref) {
        // console.log('Dialog', ref)
        if(ref === 'qrcodeDialog'){
          this.qrcode.contentHtml = '<div style="width:100%; text-align:center;"><h1>'+ this.userDetails.name+'</h1><img src="https://api.qrserver.com/v1/create-qr-code/?data=https://www.myslink.app/'+ this.userDetails.url +'" style="max-width: 275px; width: 90%; padding: 10px; background: white; border-radius: 20px;"><p style="padding-top:20px"><a href="https://myslink.app/' + this.userDetails.url + '" style="color:black" target="_blank">myslink.app/' + this.userDetails.url + '</a></div>'
        }
        this.$refs[ref].open();
      },
      openImage(image) {
        this.currentImage = event.target.src.replace('tr:n-media_library_thumbnail')
        if(image !=null){
          this.currentImage = image.source.replace('tr:9cube')
          this.currentImageDescription = image.description
          this.currentImageURL = image.url
        }
        this.$refs['imageDialog'].open();
      },
      imageDialogClose(){
        this.currentImage = null
        this.currentImageDescription = null
        this.currentImageURL = null
      }, 
      gaLoggedSlinkClink(page, link, site){
        this.$ga.event({
          eventCategory: page,
          eventAction: 'Slink Click',
          eventLabel: site,
          eventValue: null
        })
        var updateClicksRef =  db.ref('users/'+ this.userUID +'/links/'+ link +'/clicks');
        updateClicksRef.transaction(function (current_value) {
          return (current_value || 0) + 1;
        });
        // if (this.userDetails.fbPixel){
        //   window.fbq.push('track', 'Slink Click', {value: 1.00, site: site});
        // }
        // if(this.userDetails.googleAnalytics  !== "undefined"){
        //   // console.log('need to log with custom GA')
        //   // this.window.ga('send', 'event', page, 'Slink Click', site, null);
        //   window.gtag('send', {
        //     hitType: 'event',
        //     eventCategory: 'Videos',
        //     eventAction: 'play',
        //     eventLabel: 'Fall Campaign',transport: 'beacon'
        //   });
        // }
      },
      gaLoggedSponsored(page, ad, clicks){

        // console.log('ad-status', typeof(googleAd), googleAd.getAttribute('data-ad-status'))
        if( typeof(googleAd) == 'object' && googleAd.getAttribute('data-ad-status') == 'unfilled'){
          ad.title = ad.title + " unfilled"
          // console.log('unfulfilled title', ad.title)
        }
        this.$ga.event({
          eventCategory: page,
          eventAction: 'Sponsored Slink',
          eventLabel: ad.title,
          eventValue: null
        })
        console.log('ad click', ad['.key'])
        db.ref('ads/'+ ad['.key']+'/clicks').transaction(function (current_value) {
          return (current_value || 0) + 1;
        });
      },
      gaLoggedSuggested(page, suggestion, clicks){
        this.$ga.event({
          eventCategory: page,
          eventAction: 'Suggested Page',
          eventLabel: suggestion,
          eventValue: null
        })
      },
      getSectionComponent(type) {
        // Return cached component if already loaded
        if (this.loadedSections[type]) {
          return this.loadedSections[type];
        }

        // Convert type to kebab-case and lowercase for consistent file naming
        const componentName = type.toLowerCase().replace(/\s+/g, '-');
        
        // Dynamically import the component
        import(`./sections/${componentName}.vue`)
          .then(module => {
            this.$set(this.loadedSections, type, module.default);
          })
          .catch(error => {
            console.error(`Failed to load section component '${componentName}':`, error);
            // Optionally set to null or a fallback component
            this.$set(this.loadedSections, type, null);
          });

        // Return current loaded component (or null if not loaded yet)
        return this.loadedSections[type] || null;
      },
      getSectionProps(type, section) {
        // Return different props based on section type
        switch(type.toLowerCase()) {
          case 'hero':
            return {
              userDetails: this.userDetails
            }
          case 'links':
            return {
              links: this.sectionLinks(section),
              userInfo: this.userInfo,
              userDetails: this.userDetails, // if still needed by links component
              linkFormatting:  this.linkFormatting
            }
            case 'navigation':
            return {
              sections: this.userDetails.sections,
              userInfo: this.userInfo,
              userDetails: this.userDetails, // if still needed by links component
              linkFormatting:  this.linkFormatting
            }
          default:
            return {
              userDetails: this.userDetails
            }
        }
      }
    }
  }
</script>

<style>

#app {
  min-height:100dvh !important;
}
/* @font-face {
  font-family: 'hostedFont';
  src: url('/static/fonts/Simpsonfont.otf');
} */

@font-face {
  font-family: 'hostedFont';
  src: var(--customHostedFont);
}

:root{
  --linkBorder: white;
  /* --background: black !important; */
  --background: none;
  --backgroundImage: none;
  --autoBackground: white;

  /* V3 VARIABLES */
  --backgroundv3: #f5f5f5;
  --backgroundv3-alt: color-mix(in srgb, var(--backgroundv3) 80%, transparent);
 /* --customFont: url(); */
 --customHostedFont: url('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2FIkUiGnjhbCU5eMmTpgOh0SnmYFq1%2Fmisueevee.woff2?alt=media&token=68814118-1673-47db-8adc-46a0cba294d5');
 

  /* background: red */
}

section{
  background: var(--backgroundv3);
}

section:nth-child(even){
  background: var(--backgroundv3-alt);
}


.stickyProfile{
position: sticky !important;
    top: 0;
    z-index: 99;
}

.albumPlayerMargin{
  margin-bottom:70px;
}


/* @font-face { */
  /* font-family: "customFont"; */
  /* src: var(--customFont) */
   /* src:local("customFont"), url("https://cdn.myslink.app/userContent%2F-NPPWUnXILDhgPlSrMDp%2Ffont%2Fmiso.woff2?alt=media&token=e2a47f65-1684-4db8-b081-668251e6913c") format("woff2") */
/* } */

ins.adsbygoogle a {
    display: none !important;
}
ins.adsbygoogle[data-ad-status="unfilled"] a {
    display: block !important;
}

ins.adsbygoogle[data-ad-status="unfilled"] {
    /* display: none !important; */
    aspect-ratio:353.76/176.8;
    width:100% !important;
    height:unset !important;
}

#aswift_1 {
  max-height:100px;
}

#Section{
  box-shadow: none !important;
}
#app{
  background: var(--background);
  background-attachment: fixed;
    background-position: center;
    background-size: cover;
}
body {
  /* background: var(--background) !important; */
background-size: cover;
    background-attachment: fixed;
    background-position: center center;
    background-position-x: center;
    background-position-y: center;
}
.stickyPadding{
  padding-bottom: 50px;
}

.desktopFullscreen{
  max-width: unset !important;
}

.templateBelow.floating{
  gap:10px;
  display:grid;
}
/* 
.body{
  background-color: var(--background) !important;
} */

/* .coinmarketcap-currency-widget{
  width:100%
} */
::-webkit-scrollbar { 
    /* display: none;  Safari and Chrome */
    height:5px;
    
}
::-webkit-scrollbar-thumb {
    background-color: #C3C7C7 ;
    border-radius:50px
}

::-webkit-scrollbar-track {
    /* background-color: orange; */
    margin-left:10px;
    margin-right:10px;
    border-radius:50px;
    background-color: #C3C7C755;
}


.coinmarketcap-currency-widget div{
  border:unset !important
}

/* coingecko-coin-price-chart-widget{
  width:100%
} */

.embeds > * {
  width:100% !important;
  margin:unset !important;
  border:unset !important;
}

/* .linkgroupContainer > div , .linkgroupContainer .grid{
  border-radius:5px !important; 
  overflow:hidden;
} */

.linkgroupContainer .groupMember.grid{
  border-radius:7px !important; 
  overflow:hidden;
}

/* .linkgroupContainer .groupMember.grid .link .text{
  visibility: hidden;
  width:unset;
} */

.squircleSVG{
  position:relative
}

.squircleIOS {
  -webkit-clip-path:url(#squircle);
  clip-path:url(#squircle);
  width:100px !important;
  height:100px !important;
  object-position: center;
  object-fit: cover;
  position:relative;
  /* border-style:unset !important; */
  /* aspect-ratio: 1/1; */
}

/* .backgroundWallpaper::before{
  background-image: var(--autoBackground);


} */
/* .backgroundWallpaper::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(50px);
} */

/* .backgroundWallpaper::before{
  z-index:-1;
  content:"";
  position: fixed;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-image: var(--autoBackground);
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  opacity:0.5
} */


.backgroundWallpaper{
  z-index:-1;
  position: fixed;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-image: var(--autoBackground);
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  /* backdrop-filter: blur(50px); */
  opacity:0.5
}

.backgroundVideo{
  display: flex;
    width: 100%;
    justify-content: center;
  z-index:-1;
  position: fixed;
  /* width: 100vw; */
  /* max-width: 100vw; */
  height: 100vh;
  left: 0;
  top: 0;
  /* background-image: var(--autoBackground); */
  /* background-attachment: fixed; */
  /* background-repeat: no-repeat; */
  /* background-size: cover; */
  /* background-position: center; */
  /* backdrop-filter: blur(50px); */
  /* opacity:0.75 */
}

.backgroundVideo video{
      max-width: 600px;
}



.backgroundWallpaper .filter{
  backdrop-filter: blur(25px);
    content: "";
    width: 100%;
    height: 100%;
}

#app{
  display: flex;
    max-width: 450px;
    margin: 0px auto;
    min-height: 100%;
}

#home{
  flex-direction: column;
    min-height: 93vh;
    display: flex;
  /* border:5px solid blue */
  width:100%
}


.premiumSuggestion{
  border:1px red solid !important
}

.grouped .link.linkcomponent:last-child{
  border-bottom:unset !important
}

.bottomBorder{
  border-bottom: 1px solid silver
}

.fixedFrame{
  max-height: calc(100vh - 40px);
}

.linkContainer{
  overscroll-behavior: auto;
  overflow: scroll;
}

/* .gallery9cube{ */
  /* border: solid 4px white !important; */
/* } */

.gallery9cubeBorder{
  overflow:hidden
}

/* .floating .profileheader{
  border-radius: 10px;
  overflow:hidden;
  margin-bottom:10px !important;
  display: block !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.12);
} */

/* .profileheader{
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.12);
} */

.floating .profileheader .altProfile0{
  border-radius: 10px;
}

.slinksContainer .slinkItems{
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.12);
  position:relative;

}
.warning{
  background: red; 
  margin: 20px 20px 0px 20px; 
  display: flex; 
  padding: 10px; 
  border-radius: 10px;;
  color:white
}

.warning .md-avatar{
  vertical-align:top;
  border-width: 2px; 
  border-color: white; 
  border-style: solid;
  text-align: center;
  margin-right:16px
}

.noborder{
  border-radius: unset !important;
  overflow:hidden;
  margin-bottom:10px !important;
  display: block !important;
  box-shadow: unset !important;
  margin-bottom:unset !important; 

}

.linksWithExpand{
  /* min-height: unset; */
  display: inline-flex;
  width: 100%;
  max-width: 100%;
}

.floating .links{
  /* width:100%; */
  border-radius: 10px;
  /* overflow:hidden; */
  /* z-index:0; */
  /* display:flex; */
  /* margin-bottom:10px !important; */
  /* display: inline-flex; */
  /* box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.12); */
}

.floating.link .flat{
  box-shadow: unset;
  /* border:1px solid whitesmoke !important; */
  /* border: 1px solid whitesmoke */

}

/* .floating .links .flat{
  box-shadow: unset;

} */

.floating .profileheader.flat{
  box-shadow: unset;
  /* border: 1px solid silver */

}


.flat{
  box-shadow: unset !important;
  /* border: 1px solid silver */
}

/* .slinkItems   .link.flat{ */
  /* border:1px solid silver */
/* } */

.flat .border{
  border: 1px solid whitesmoke !important

}

.slinksContainer.flat .slinkItems{
  box-shadow: unset;
  /* border:1px solid silver */
}

.md-whiteframe-0dp.flat{
  /* border: 1px solid whitesmoke; */
  overflow: hidden;

}

.links .md-list-item-container.md-button{
  border-radius: unset;
}

.floating .links .groupLinks{
  width:100%;
  border-radius: 0px !important;
  overflow:hidden;
  margin-bottom:0px !important;
  display: inline-flex;
  box-shadow: unset !important;
}

.group .md-list-item-container{
  padding:unset
}

/* .floating .section{ */
  /* border-bottom:5px solid silver; */
  /* border-right:5px solid silver; */
  /* border-top:none; */
  /* border-left:none */

/* } */

#Section .link .link{
  display:flex;
  text-align:center
}
/* .floating > .links{
  border-radius: 10px;
  overflow:hidden;
  margin-bottom:10px !important;
  display: block !important
} */


tbody tr:nth-child(odd) {
  background: #eee;
}
tbody tr td, th {
  padding: 5px 5px;
  /* width:50%; */
  text-transform: capitalize
}
.md-list.md-double-line .md-list-item .md-list-item-container{
  min-height:unset
}

.imageDialog .md-reference{
  border-radius:15px;
  min-width:min-content
}
.imageDialog .md-reference .md-dialog-content{
  padding:5px;
}

.imageDialog .md-reference .md-dialog-content img{
  border-radius:10px;
  width:100%;
}

/* .nameBackground{
  background: linear-gradient(180deg, rgba(255,255,255,0) 10%, rgba(0,0,0,0.1) 100%);
} */

/* .profileAlt2 .md-list-item-container{
  padding:unset
} */

.videoBox .player .finishCover{
  display:none !important
}

.bannerAd a.md-list-item-container.md-button{
  padding:unset
}


.tiktokDialog .md-dialog{
    max-width: calc(100vw - 40px);
    width: 100%;
    border-radius: 20px;
    height: fit-content;
}

.qrDialog .md-dialog{
  /* min-width: 350px; */
    max-width: 400px;
    width: 100%;
    border-radius: 20px 20px 0 0;
    height: fit-content;
    position: absolute;
    bottom: 0px;
}

.qrDialog .md-dialog .md-title, .tiktokDialog .md-dialog .md-title {
  text-align: center;
  font-weight:bold;
}

.imageSlink{
    padding: 0 0px;
    display:block;
    margin:0px;
    width:100%;
    max-width:100%;
    position: relative;
    overflow:hidden;
}

.socialShare .md-list-item-container {
    padding: 0px;
    padding-top: 5px; 
    min-height:unset !important;
    display:flex;
    justify-content:center
}

.section{
  margin:0px !important;
  width:100%;
  max-width:100%; 
  border-top:silver; 
  border-top-style:solid; 
  border-top-width: thick; 
  background: linear-gradient(0deg, white 0%, whitesmoke 100%);
}

.section .md-list-item-container {
    min-height:unset !important;
}

.links .customDescription{
  position: relative;
  top: -16px; 
  white-space: pre-wrap;
  color:black;
}

.imageLabel{
  /* background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.2) 100%); */
  position: absolute;
  width:100%;
  color: white; 
  vertical-align: bottom;
  top: 0; left:0; height:100%
}

.imageLabel .imageLabelText{
  background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
  position: absolute;
  bottom:0;
  width:100%;
  color: white; 
  padding: 10px 16px;
}

.imageLabel .imageLabelText .description{
  font-size:16px;
  font-weight:bold
}



/* body{ */
  /* height:100% !important */
/* } */



.md-theme-default.md-list .md-list-item-expand .md-list-item-container
{
  background:unset
}

#selectSite .md-dialog {
  max-width: 100%;
  max-height: calc(100% - 48px);
  top: 24px;
}

#addSite .md-dialog {
  max-width: 100%;
  width:100%;
  max-height: 100%;
  /* max-height: calc(100% - 48px); */
  height: 100%;
  /* height: calc(100% - 48px); */
  /* top: 24px; */
  
}

.hideIconEmbed{
  padding-left: 40px;
}

.standardLink .md-list-item-container.md-button{
  min-height:72px !important
}

.compactLinks .md-list-item-container.md-button{
  min-height:56px !important;
}

.compactLinks{
  min-height:56px;
}

.clear{
  /* border-bottom:unset !important; */
  border: 2px solid var(--linkBorder);
  background:unset !important;
 
}

.iconStyle2 .md-list-item-container.md-button{
  padding-left:unset;
  /* padding-right:unset; */
  /* padding-right:10px; */
}

/* .iconStyle2 .md-list-item-container.md-button .siteicon{
  height:100%;
} */

.iconStyle2 .md-list-item-container.md-button .siteicon .md-avatar{
  margin-top:unset;
  margin-bottom:unset;
  border:unset;
  border-radius:unset;
  border-right:1px solid #f5f5f577;
  box-shadow:unset;
  /* border-bottom:0.5px solid silver; */
  /* height:100%; */
}

/* .iconStyle1 .md-list-item-container.md-button{

} */
.iconStyle1 .md-list-item-container.md-button .siteicon .md-avatar{
  /* margin-top: 10px; */
  border-radius:7px;
  /* min-width:36px; */
  /* width:36px; */
  /* min-height:36px; */
  /* height:36px; */
}

.compactLinks.iconStyle1 .md-list-item-container.md-button .siteicon .md-avatar{
  margin-top: 10px;
  border-radius:7px;
  min-width:36px;
  width:36px;
  min-height:36px;
  height:36px;
}

/* .compactLinks.iconStyle1 .md-list-item-container.md-button .siteicon .md-avatar i{
  padding-top: 9px;
    padding-left: 9px;
} */

.standardLink.iconStyle2 .md-list-item-container.md-button .siteicon .md-avatar{
  height:80px;
  width:80px;
}

.groupHeader{
  padding-left:16px !important
}

.standardLink.iconStyle2 .md-list-item-container.md-button .siteicon .md-avatar img.largeIcon{
  height:48px !important;
  width:48px !important;
  margin:16px !important;
}

.compactLinks.iconStyle2 .md-list-item-container.md-button .siteicon .md-avatar{
  height:56px;
  width:56px;
}

/* .iconStyle2 .md-list-item-container.md-button .siteicon .md-avatar .fa{
  padding-top:24px
} */

/* .compactLinks.iconStyle2 .md-list-item-container.md-button .siteicon .md-avatar .fa{
  padding-top:20px
} */

/* .iconStyle2 .md-list-item-container.md-button .siteicon .md-avatar .fa-3x{
  padding-top:16px
} */

/* .iconStyle2 .md-list-item-container.md-button .siteicon .md-avatar{
  padding: 10px;
  object-fit: contain;
} */

/* .iconStyle2 .md-list-item-container.md-button .siteicon .md-avatar img.compactIcon{
  padding: 10px;
  object-fit: contain;
  height: unset;
    width: 100%;
    margin: unset !important;
} */
._embed_video_wrapper{
  max-width:unset !important
}

.sona-widget .image .link, .sona-widget .image .link .resource{
  width:100% !important
}

/* .juicyAds iframe{
  width:100% !important;
  z-index: unset !important; 
    border: unset !important;
    background-color: unset !important;
    position: unset !important;
    visibility: unset !important;
    clear: unset !important;
    aspect-ratio:300/100 !important;
    height:unset !important;
} */

.linkgridContainer{
  background:unset !important;
}

.linkgridContainer .link{
  width:unset !important;
  flex:1;
  min-width:75px;
  max-width:90px;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


#Bookmarks{
  position:-webkit-sticky; position:sticky; top:0;
  /* -webkit-position: sticky;
  position: -webkit-sticky;
position: -moz-sticky;
position: -o-sticky;
position: -ms-sticky;
position: sticky; */
    top: 10px;
    z-index: 10;
    display:block;
}

#Bookmarks.bookmarkFullScreen{
  /* position: sticky; */
  position:-webkit-sticky; position:sticky; top:0;
    top: 0px; 
    z-index: 10 !important;
}
 
.slinkItems.allowOverflow{
  overflow-y:auto !important;
}
.bookmarks{
  padding:5px 7px; 
  display: flex; 
  /* border-bottom: 1px solid silver; */
  /* justify-content: flex-start; */
  font-weight:bold; 
  /* flex-wrap: wrap; */
  overflow-x: auto;
  justify-content: space-between;
}

.bookmarks .bookmark{
  font-size: smaller; 
  border-radius: 5px; 
  /* border-radius: 50px;  */
  font-weight: bold; 
  min-height: 24px; 
  line-height: 24px; 
  height: 24px; 
  /* min-width: 50px;  */
  margin: 6px 4px; 
  padding: 0px 10px;
  min-width:fit-content;
}

.bookmarks .bookmark.home{
  min-width: 24px; 
  width: 24px; 
}

.qlbTransparent{
  background: none !important;
  box-shadow:none;
  padding: 0 0 2px 0 !important;
  border:unset !important;
  padding:6px !important;
}



.quicklinksBar{
  justify-content:space-evenly; 
  width: 100%; 
  display:flex; 
  flex-wrap:wrap; 
  /* padding: 0px 0px 6px 0px;  */
  /* padding-bottom: 6px; */
}

.quicklinksBar.style0{
  padding:8px;
}
.quicklinksBar.iconStyle2{
 /* margin-top:unset !important;
 min-width:56px;
 min-height:56px; */
 padding:0px;
 justify-content: space-between;
 max-height:56px;
}

.quicklinksBar.style3{
  justify-content:space-evenly; 
  width: 100%; 
  display:flex; 
  flex-wrap:wrap; 
  
}

.quicklinksBar.style1 .quickLinkButton, .quicklinksBar.style2 .quickLinkButton, .quicklinksBar.style3 .quickLinkButton{
  /* width:100%; */
  min-height:56px;
  display:flex;
  flex-grow: 1;
  border-width:0px 1px 0px 0px; 
  border-style: solid;
  border-color: #f5f5f577
}

.quicklinksBar.style1 .quickLinkButton:last-child, .quicklinksBar.style2 .quickLinkButton:last-child, .quicklinksBar.style3 .quickLinkButton:last-child{
  /* width:100%; */
  min-height:56px;
  display:flex;
  border:unset;
}

.quicklinksBar.iconStyle2_ .quickLinkButton{
 margin-top:unset !important;
  /* min-width:56px; */
 min-height:56px;
 flex-grow:1;
 padding:0px
}

.quicklinksBar.iconStyle2_ .quickLinkButton:last-child{
 /* margin-top:unset !important; */
  /* min-width:56px; */
 /* min-height:56px; */
 /* flex-grow:1; */
 /* padding:0px */
 border:unset;
}

.quicklinksBar.iconStyle2_ .quickLinkButton .siteicon{
 min-width:56px;
 min-height:56px;
 margin:unset;
 /* background:red */
}

.quicklinksBar .quickLinkButton1{
  display:flex;
  border-radius:unset;
    min-width:56px;
    min-height:56px;
    /* padding:8px; */
    width:100%;
    border-width:0px 1px 0px 0px; 
    border-style: solid;
    border-color: #f5f5f577
}

.quicklinksBar .quickLinkButton1:last-child{
  border-radius:unset;
    min-width:56px;
    min-height:56px;
    /* padding:8px; */
    width:100%;
    border-width:0px 0px 0px 0px; 
    border-style: solid;
    border-color: #f5f5f577
}

/* .quicklinksBar .quickLinkButton .siteicon{
  
} */


/* .quicklinksBar.iconStyle2 .quickLinkButton .siteicon .md-avatar{ */
 /* border-radius: 100px  !important; */
    /* min-width: 56px !important; */
    /* width: 100%; */
    /* min-height: 56px; */
    /* padding: 8px; */
/* } */


/* .iconStyle2 .md-avatar{
 background:red;
 border-radius:unset
} */

.shareIcon{
  padding-left: unset; 
  padding-right: unset; 
  min-width: unset; 
  width: unset; 
  margin:0px 2px 0px 2px;
  padding-top:6px;
}

.shareIcon i{
  padding-top:6px !important;
}

.md-select-content{
  width:100% !important;
}

.md-theme-default.md-list .md-list-item-expand .md-list-item-container{
  background-color:unset
}

/* body{
  background-color: "whitesmoke";
} */

section{
  padding-bottom:30px;
}

h1, h2 {
  font-weight: normal;
  /* font-family: 'Pacifico'; */
  text-align: center;
}

h2{
  font-size:10ex;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

#profileBackground{
  background-color:white;
  padding-top:15px;
  background-position: center;
  background-repeat: no-repeat;
  /* background-size:cover; */
  background-size: 150vw;
  text-align: center;
}

#profilePic{
  background-position: center;
  background-repeat: no-repeat;
  background-size:cover;
  /* width: 100px;
  height: 100px;
  max-width: 100px;
  max-height: 100px; */
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, .75);
  margin-left:auto;
  margin-right:auto;
}

#profilePicAlt{
  background-position: center;
  background-repeat: no-repeat;
  background-size:cover;
  /* width: 100px;
  height: 100px;
  max-width: 100px;
  max-height: 100px; */
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  border: 3px solid rgba(255, 255, 255, .75);
  margin-left:auto;
  margin-right:auto;
}

/* .gold{
  border: 3px solid gold !important;
} */

/* #slinkName{
  color:black;
  font-size:18px;
  margin-top:10px;
  margin-bottom:10px;
  padding-left:10px;
  padding-right:10px;
  background-color:rgba(0, 0, 0, 0.25);
  white-space:nowrap;
  display:inline-block;
  border-radius:10px;
} */

.md-list-item-container{
  padding: 10px 16px;
}



.md-theme-default.md-list .md-list-item-expand .md-list-item-container{
  background-color:unset
}

.imageCarousel{
  background-color:red;
  /* padding:100px */
  
}

.md-list-item .imageCarousel .md-list-item-container{
  padding:unset
}

.profileAlt.md-list.md-double-line .md-list-item .md-list-item-container 
{
  min-height: inherit
}

.slinksContainer{
  padding:20px;
  width:100%;
  min-height:56px;
  /* display:grid; */
  display: flex;
    flex-direction: column;
  /* gap: 10px; */
  /* additional class for floating */
}

.slinksContainer.fullScreen{
  padding:unset;
}

.slinksContainer.floating.iOSDevice .slinkItems{
  /* border:1px solid red; */
  margin-bottom:10px !important;
  /* overflow:hidden; */
  /* border-radius:12px !important; */
}

.slinkItems.linkBorder{
  border:2px solid var(--linkBorder);
  border-radius: 12px !important;
  overflow:hidden;
}

.slinksContainer.floating.iOSDevice{
  gap: unset;
}

.slinksContainer.floating{
  gap: 10px;
}

summary:active {
    border:none;
}

/* .slinksContainer.floating .profileheader{
  border-radius:10px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.12);
} */


/* .slinksContainer.floating .link .link{
  border-radius:10px;
} */
/* 
.link.style2 .link{
  padding:unset !important; 
} */

/* .link.style0 summary .container{
  padding:8px;
} */
/* .link.style0 .container{
  grid-template-columns: 80px auto 40px !important;
} */

.link.style3 summary .container{
  grid-template-columns: auto !important;
  justify-content:center;
  text-align:center;
  /* background:pink; */
}

/* .link.style3 .link .icon{
  display:none;
} */

.link.style3 summary .container .icon{
  display:none;
}

.link.style1.compact details summary .container{
  grid-template-columns: 56px auto 40px !important;
  padding:unset;
}

.link.style0.compact summary .container{
  grid-template-columns: 56px auto 40px !important;
  padding:unset;
}

.link.style0.compact summary .container .icon{
  padding-top:8px;
}

.link.style0.compact summary .container .icon .sitecion{
  margin:unset;
}

.link.style1 summary{
  padding:8px;
}

.link.style1.compact details summary .container{
  padding:unset;
}

.container .icon{
  width: 56px;
  /* width:100%; */
  aspect-ratio: 1/1;
  justify-content: center;
    align-items: center;
    display: -webkit-inline-box;
    padding:8px;
}

.compact .container .icon{
  padding:unset !important;
}

.link.style1.compact summary{
  padding:unset;
}

.link.style1.compact summary .container .icon{
  padding:unset !important;
}

.link.style1 summary div .icon{
  padding:unset !important;
}
.link.style1.compact summary div .icon{
  padding:8px !important;
}

.link.style1.compact.groupMember .link .icon, .link.style2.groupMember .link .icon .siteicon.style2{
  padding:unset !important;
  /* display:flex; */
}

.groupMember{
  border-bottom:1px solid var(--linkBorder);
}

.link.style1 summary div .text{
  padding-left:16px !important;
}

/* .link.style2 summary div .text{ */
  /* padding-left:26px !important */
/* } */

.link.style2.compact summary .container{
  grid-template-columns: 56px auto 40px !important;
}

.link.style2.compact summary div .text{
  padding-left:unset !important
}

.slinksContainer.floating .slinkItems{
  border-radius:10px;
  overflow:hidden;
}


.slinksContainer.notFloating.iOSDevice{
  border-radius: 10px;
  overflow:hidden;
  /* -webkit-border-radius: 500px; */
/* -moz-border-radius: 500px; */
}

.slinksContainer.notFloating.iOSDevice .profileheader{ 
  z-index:0
}

.slinksContainer.notFloating .slinkItems:first-child{
  border-radius: 10px 10px 0px 0px;
  overflow:hidden;
}

.slinksContainer.notFloating .slinkItems:last-child{
  border-radius: 0px 0px 10px 10px;
  overflow:hidden;
}

.slinksContainer.notFloating.fullScreen .slinkItems:first-child{
  border-radius: unset;
  overflow:hidden;
}

.slinksContainer.notFloating.fullScreen .slinkItems:last-child{
  border-radius: unset;
  overflow:hidden;
}


.quickLinkButton .compactIcon{
  width:24px;
  height:24px;
}

.compactIcon{
  width:24px !important;
  height:24px !important;
}


.link.style2 summary div .icon{
  padding-top:unset !important;
}
/* .slinksContainer .link{
  width:100%;
  min-height:80px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.12);
  overflow:hidden;
  background:white;
  display:grid;
  grid-template-columns: 80px auto 40px;
  gap:12px;

}
.slinksContainer .link.compact{
  grid-template-columns: 56px auto 40px;
  min-height:56px;
}

.slinksContainer .link.floating{
    border-radius:10px;
}

.slinksContainer .link .icon{
  width:100%;
  aspect-ratio: 1/1;
  justify-content: center;
    align-items: center;
    display: -webkit-inline-box;
}

.style0 .icon img{
  border-radius:50%;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
  background:white; 
}

.siteicon .style1 .md-avatar{
  border-radius:7px;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
  background:pink; 
}

.style1 .icon img{
  border-radius:7px;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
  background:white; 
}

.style2 .icon{
  background: pink;
  border-right:1px solid #f5f5f555
}

.style2 .icon img{
  border-radius:50%;
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
  background:white; 
}

.slinksContainer .link .text{
  padding-top:16px;
  padding-bottom:16px;
  align-items: center;
  display: grid; 
  width:100%; 
}

.slinksContainer .link.compact .text{
  padding-top:8px;
  padding-bottom:8px;
  align-items: center;
  display: grid; 
  width:100%; 
}

.slinksContainer .link .text .title{
  font-weight:bold;
  font-size:16px;
}

*/

/* details .link{

} */

.shake{
  animation: shake 2.0s;
  animation-iteration-count: infinite;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

.quickLinksIconStyle1, .quickLinksIconStyle2{
  box-shadow: unset;
    /* color: rgb(187, 180, 139); */
    border-radius: unset;
    /* background: rgb(0, 0, 0); */
    height: 56px;
    width: 100%;
}



.ribbon {
  width: 200px;
  height: 200px;
  overflow: hidden;
  position: absolute;
  z-index:1;
}

.ribbon span {
  position: absolute;
  display: block;
  width: 200px;
  padding: 10px 0;
  background-color: #FF793B;
  box-shadow: 0 5px 10px rgba(0,0,0,.1);
  color: #fff;
  font: 700 14px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  text-transform: uppercase;
  text-align: center;
}

/* top left*/
/* .ribbon-top-left { */
  /* top: 50px; */
  /* left: 25px; */
/* } */
.ribbon-top-left span {
  right: 50px;
  top: 30px;
  transform: rotate(-45deg);
}

.link.style1.compact summary .container{
  grid-template-columns: 56px auto 40px !important;
  padding:unset;
}

#Gallery\ Grid{
  background: unset;
    overflow: unset;
    box-shadow:unset;
}

#Gallery\ Grid .link{
  background: unset;
    overflow: unset;
    box-shadow:unset;
}

._embed_video_wrapper{
  max-width:unset !important
}

#LinkGroup .link summary .container .icon .md-avatar{
  margin-top:0px
}
.md-avatar.siteicon.md-theme-default.style2.compact{
  margin-top:0px
}

.link.style2.compact .link .icon{
  height:100%
}

#Link\ Group{  
  position:initial
}

details[open] summary i.more{
  display:none;
}

details[open] summary i.less{
  display:unset;
}

details summary i.less{
  display:none;
}

.stickyFooter{
  position: fixed;
    bottom: 0;
    padding:5px;
}

/* .stickyFooter::before{
  margin-bottom:20px;
} */
.stickyFooter.albumPlayer{
  z-index: 100;
  width:100%;
  /* color:white; */
  /* border:1px solid red; */
  display: flex;
    align-items: center;
    justify-content: center;
    max-width: 450px;
    padding:5px 5px;
    display:flex;
    flex-direction: column;
    
    
}
.stickyFooter.albumPlayer .controls{
  background:black;
  width:100%;
  border-radius:10px 10px;
  overflow:hidden;
  /* border:1px solid whitesmoke; */
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.14), 0 1px 14px rgba(0, 0, 0, 0.12);
}

.controls button{
  color: whitesmoke;
}
</style>


// WEBPACK FOOTER //
// src/components/slinkview.vue